// Generated by scripts/emit-client.ts — do not edit.
// Run `npm run codegen` after changing any capability contract; `npm run codegen:check` gates drift in CI.

/** Every capability, with the input/output types clients hold and the facts the client needs at runtime. */
export interface CapabilityContracts {
  /** Browse open auctions, ending soonest first. */
  'auctions.auction.browse': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      sellerRef?: string;
      limit?: number;
      cursor?: string;
    };
    output: {
      auctions: Array<{
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'public';
    errors: never;
  };
  /** Cancel an auction that has no bids. */
  'auctions.auction.cancel': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      auctionId: string;
    };
    output: {
      cancelled: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'AUCTION_NOT_FOUND' | 'AUCTION_HAS_BIDS' | 'AUCTION_NOT_ACTIVE';
  };
  /** The lots running in a show, and the ones already finished. */
  'auctions.auction.current': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
      limit?: number;
    };
    output: {
      live: Array<{
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      }>;
      done: Array<{
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      }>;
    };
    idempotency: 'none';
    access: 'public';
    errors: never;
  };
  /** Read one auction. */
  'auctions.auction.get': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      auctionId: string;
    };
    output: {
      auction: {
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      };
    };
    idempotency: 'none';
    access: 'public';
    errors: 'AUCTION_NOT_FOUND';
  };
  /** Put one of your listings on the block during a live show. */
  'auctions.auction.launch': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      /** UUID, lowercase canonical form */
      showId: string;
      durationSeconds: number;
    };
    output: {
      auction: {
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SHOW_NOT_FOUND' | 'SHOW_NOT_LIVE' | 'SELLER_NOT_PAYABLE' | 'LISTING_NOT_FOUND' | 'NOT_AUCTIONABLE' | 'LISTING_ALREADY_AT_AUCTION' | 'NO_INVENTORY';
  };
  /** Open a timed auction on one of your published listings. */
  'auctions.auction.schedule': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      durationMinutes: number;
    };
    output: {
      auction: {
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SELLER_NOT_PAYABLE' | 'DURATION_TOO_SHORT' | 'LISTING_NOT_FOUND' | 'NOT_AUCTIONABLE' | 'LISTING_ALREADY_AT_AUCTION' | 'NO_INVENTORY';
  };
  /** Close an auction that has reached its end time. */
  'auctions.auction.settle': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      auctionId: string;
    };
    output: {
      auction: {
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'AUCTION_NOT_FOUND';
  };
  /** Read an auction bid history. */
  'auctions.bid.history': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      auctionId: string;
      limit?: number;
    };
    output: {
      bids: Array<{
        sequence: number;
        displayName: string;
        you: boolean;
        /** Money in integer cents (USD) */
        priceCents: number;
        tookLead: boolean;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        placedAt: string;
      }>;
    };
    idempotency: 'none';
    access: 'public';
    errors: 'AUCTION_NOT_FOUND';
  };
  /** Place a max bid on an active auction. */
  'auctions.bid.place': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      auctionId: string;
      /** Positive money amount in integer cents (USD) */
      maxCents: number;
    };
    output: {
      auction: {
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      };
      position: {
        standing: "none" | "winning" | "outbid" | "won" | "lost";
        /** Money in integer cents (USD) */
        maxCents?: number;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        exposureCents: number;
        /** Money in integer cents (USD) */
        exposureCapCents: number;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'AUCTION_NOT_FOUND' | 'NOT_A_BIDDER' | 'INELIGIBLE_NO_CARD' | 'INELIGIBLE_BLOCKED' | 'EXPOSURE_CAP_EXCEEDED' | 'AUCTION_NOT_ACTIVE' | 'AUCTION_ENDED' | 'BID_TOO_LOW' | 'ALREADY_LEADING_HIGHER' | 'SELLER_CANNOT_BID' | 'CONCURRENT_BID';
  };
  /** Read your own position in an auction. */
  'auctions.bid.position': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      auctionId: string;
    };
    output: {
      position: {
        standing: "none" | "winning" | "outbid" | "won" | "lost";
        /** Money in integer cents (USD) */
        maxCents?: number;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        exposureCents: number;
        /** Money in integer cents (USD) */
        exposureCapCents: number;
      };
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'AUCTION_NOT_FOUND' | 'NOT_A_BIDDER';
  };
  /** Buy an auction item outright at the seller buy-it-now price. */
  'auctions.buynow.purchase': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      auctionId: string;
    };
    output: {
      auction: {
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      };
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'AUCTION_NOT_FOUND' | 'NOT_A_BIDDER' | 'BUY_NOW_UNAVAILABLE' | 'SELLER_CANNOT_BID' | 'CONCURRENT_BID';
  };
  /** Publish a bidder eligibility fact to the auction engine. */
  'auctions.eligibility.set': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
      hasCardOnFile: boolean;
      blocked?: boolean;
    };
    output: {
      recorded: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: never;
  };
  /** Record whether a won auction was paid for, failed, or is deferred. */
  'auctions.settlement.report': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      auctionId: string;
      outcome: "paid" | "failed" | "deferred";
    };
    output: {
      auction: {
        /** UUID, lowercase canonical form */
        auctionId: string;
        /** UUID, lowercase canonical form */
        listingRef: string;
        /** UUID, lowercase canonical form */
        sellerRef: string;
        title: string;
        mediaKeys: string[];
        condition?: string;
        categoryPath?: string;
        status: "active" | "closed_won" | "closed_no_sale" | "cancelled";
        /** UUID, lowercase canonical form */
        showRef?: string;
        /** Money in integer cents (USD) */
        startPriceCents: number;
        /** Money in integer cents (USD) */
        currentPriceCents: number;
        bidCount: number;
        leaderDisplayName?: string;
        /** Money in integer cents (USD) */
        nextBidCents: number;
        /** Money in integer cents (USD) */
        incrementCents: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endsAt: string;
        /** Timestamp, epoch milliseconds (UTC) */
        endTimeMs: number;
        /** Timestamp, epoch milliseconds (UTC) */
        serverNowMs: number;
        extensionCount: number;
        softCloseWindowMs: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        closedAt?: string;
        winnerDisplayName?: string;
        /** Money in integer cents (USD) */
        clearingPriceCents?: number;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'AUCTION_NOT_FOUND' | 'NOT_AWAITING_SETTLEMENT' | 'SETTLEMENT_FINAL';
  };
  /** Fetch one category’s attribute template. */
  'catalog.category.get': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      categoryId: string;
    };
    output: {
      category: {
        /** UUID, lowercase canonical form */
        categoryId: string;
        /** UUID, lowercase canonical form */
        parentId?: string;
        slug: string;
        name: string;
        path: string;
        listable: boolean;
        authenticationRequired: boolean;
        brandRequired: boolean;
        offered: boolean;
      };
      attributes: Array<{
        key: string;
        label: string;
        dataType: "string" | "integer" | "decimal" | "enum" | "boolean" | "date";
        unit?: string;
        options?: Array<{
          /** UUID, lowercase canonical form */
          id: string;
          name: string;
        }>;
        validation?: {
          min?: number;
          max?: number;
          pattern?: string;
          maxLength?: number;
        };
        facetable: boolean;
      }>;
      entries: Array<{
        key: string;
        required: boolean;
        variantEligible: boolean;
        displayOrder: number;
        inputType?: "list" | "free_text";
      }>;
    };
    idempotency: 'none';
    access: 'public';
    errors: 'CATEGORY_NOT_FOUND';
  };
  /** Move a catalog import to its next phase and return what that phase works on. */
  'catalog.import.advance': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      to: "fetching_images" | "imported" | "publishing" | "published";
      attempt?: number;
    };
    output: {
      status: "awaiting_upload" | "queued" | "verifying" | "rejected" | "awaiting_confirmation" | "importing" | "fetching_images" | "imported" | "publishing" | "published" | "expired";
      batches: Array<{
        from: number;
        to: number;
      }>;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'IMPORT_NOT_FOUND' | 'INVALID_TRANSITION';
  };
  /** Analyze an uploaded catalog import file and propose its column mapping. */
  'catalog.import.begin': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      etag?: string;
      confirmDuplicate?: boolean;
    };
    output: {
      job: {
        /** UUID, lowercase canonical form */
        jobId: string;
        status: "awaiting_upload" | "queued" | "verifying" | "rejected" | "awaiting_confirmation" | "importing" | "fetching_images" | "imported" | "publishing" | "published" | "expired";
        phase: "upload" | "verifying" | "confirm" | "rows" | "images" | "publishing" | "done";
        fileName: string;
        requestedFormat?: "going-once" | "whatnot" | "shopify";
        source?: "csv-going-once" | "csv-whatnot" | "csv-shopify" | "csv-user";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
        stalled: boolean;
        verification?: {
          ok: boolean;
          encoding?: "utf-8" | "utf-8-bom";
          bytes: number;
          rowCount: number;
          errors: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
          warnings: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
        };
        proposal?: {
          rowCount: number;
          productCount: number;
          format?: "going-once" | "whatnot" | "shopify";
          formatSource: "requested" | "detected" | "none";
          fromSavedProfile: boolean;
          columns: Array<{
            index: number;
            header: string;
            samples: string[];
            suggested: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
            confidence: number;
            distinct?: Array<{
              value: string;
              count: number;
              category?: {
                /** UUID, lowercase canonical form */
                categoryId: string;
                confidence: number;
              };
            }>;
            needsReview: boolean;
            alternatives: Array<{
              target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
              confidence: number;
            }>;
          }>;
          notices: Array<{
            code: string;
            message: string;
            count?: number;
          }>;
        };
        mapping?: Array<{
          index: number;
          target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
        }>;
        categories?: {
          values?: Array<{
            value: string;
            category: string | "uncategorized";
          }>;
          fallback?: string | "uncategorized";
        };
        counts: {
          total: number;
          processed: number;
          created: number;
          updated: number;
          unchanged: number;
          skipped: number;
          failed: number;
          imagesFetched: number;
          imagesFailed: number;
          published: number;
          publishFailed: number;
          publishSkipped: number;
          uncategorized: number;
          stockAdded: number;
        };
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'IMPORT_NOT_FOUND' | 'IMPORT_EXPIRED' | 'IMPORT_IN_PROGRESS' | 'DUPLICATE_FILE' | 'PIPELINE_UNAVAILABLE' | 'CONCURRENT_UPDATE';
  };
  /** Confirm an import’s column mapping and start importing. */
  'catalog.import.confirm': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      mapping: Array<{
        index: number;
        target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
      }>;
      categories?: {
        values?: Array<{
          value: string;
          category: string | "uncategorized";
        }>;
        fallback?: string | "uncategorized";
      };
      remember?: boolean;
    };
    output: {
      job: {
        /** UUID, lowercase canonical form */
        jobId: string;
        status: "awaiting_upload" | "queued" | "verifying" | "rejected" | "awaiting_confirmation" | "importing" | "fetching_images" | "imported" | "publishing" | "published" | "expired";
        phase: "upload" | "verifying" | "confirm" | "rows" | "images" | "publishing" | "done";
        fileName: string;
        requestedFormat?: "going-once" | "whatnot" | "shopify";
        source?: "csv-going-once" | "csv-whatnot" | "csv-shopify" | "csv-user";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
        stalled: boolean;
        verification?: {
          ok: boolean;
          encoding?: "utf-8" | "utf-8-bom";
          bytes: number;
          rowCount: number;
          errors: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
          warnings: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
        };
        proposal?: {
          rowCount: number;
          productCount: number;
          format?: "going-once" | "whatnot" | "shopify";
          formatSource: "requested" | "detected" | "none";
          fromSavedProfile: boolean;
          columns: Array<{
            index: number;
            header: string;
            samples: string[];
            suggested: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
            confidence: number;
            distinct?: Array<{
              value: string;
              count: number;
              category?: {
                /** UUID, lowercase canonical form */
                categoryId: string;
                confidence: number;
              };
            }>;
            needsReview: boolean;
            alternatives: Array<{
              target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
              confidence: number;
            }>;
          }>;
          notices: Array<{
            code: string;
            message: string;
            count?: number;
          }>;
        };
        mapping?: Array<{
          index: number;
          target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
        }>;
        categories?: {
          values?: Array<{
            value: string;
            category: string | "uncategorized";
          }>;
          fallback?: string | "uncategorized";
        };
        counts: {
          total: number;
          processed: number;
          created: number;
          updated: number;
          unchanged: number;
          skipped: number;
          failed: number;
          imagesFetched: number;
          imagesFailed: number;
          published: number;
          publishFailed: number;
          publishSkipped: number;
          uncategorized: number;
          stockAdded: number;
        };
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'IMPORT_NOT_FOUND' | 'IMPORT_NOT_AWAITING_CONFIRMATION' | 'IMPORT_EXPIRED' | 'MAPPING_INVALID' | 'IMPORT_IN_PROGRESS' | 'PIPELINE_UNAVAILABLE' | 'CONCURRENT_UPDATE';
  };
  /** Attach fetched import photos to their listings and record the ones that failed. */
  'catalog.import.images': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      rows: Array<{
        line: number;
        /** UUID, lowercase canonical form */
        listingId: string;
        images: Array<{
          url: string;
          outcome: "fetched" | "failed";
          code?: string;
          key?: string;
          contentType?: "image/jpeg" | "image/png" | "image/webp" | "image/heic";
          sizeBytes?: number;
        }>;
      }>;
    };
    output: {
      attached: number;
      failed: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'IMPORT_NOT_FOUND';
  };
  /** List the image URLs a range of import rows still needs fetched. */
  'catalog.import.imagework': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      range: {
        from: number;
        to: number;
      };
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      rows: Array<{
        line: number;
        /** UUID, lowercase canonical form */
        listingId: string;
        urls: string[];
        capacity: number;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'IMPORT_NOT_FOUND';
  };
  /** List the calling seller’s recent catalog imports. */
  'catalog.import.list': {
    kind: 'query';
    input: {
      limit?: number;
    };
    output: {
      jobs: Array<{
        /** UUID, lowercase canonical form */
        jobId: string;
        status: "awaiting_upload" | "queued" | "verifying" | "rejected" | "awaiting_confirmation" | "importing" | "fetching_images" | "imported" | "publishing" | "published" | "expired";
        phase: "upload" | "verifying" | "confirm" | "rows" | "images" | "publishing" | "done";
        fileName: string;
        requestedFormat?: "going-once" | "whatnot" | "shopify";
        source?: "csv-going-once" | "csv-whatnot" | "csv-shopify" | "csv-user";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
        stalled: boolean;
        verification?: {
          ok: boolean;
          encoding?: "utf-8" | "utf-8-bom";
          bytes: number;
          rowCount: number;
          errors: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
          warnings: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
        };
        proposal?: {
          rowCount: number;
          productCount: number;
          format?: "going-once" | "whatnot" | "shopify";
          formatSource: "requested" | "detected" | "none";
          fromSavedProfile: boolean;
          columns: Array<{
            index: number;
            header: string;
            samples: string[];
            suggested: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
            confidence: number;
            distinct?: Array<{
              value: string;
              count: number;
              category?: {
                /** UUID, lowercase canonical form */
                categoryId: string;
                confidence: number;
              };
            }>;
            needsReview: boolean;
            alternatives: Array<{
              target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
              confidence: number;
            }>;
          }>;
          notices: Array<{
            code: string;
            message: string;
            count?: number;
          }>;
        };
        mapping?: Array<{
          index: number;
          target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
        }>;
        categories?: {
          values?: Array<{
            value: string;
            category: string | "uncategorized";
          }>;
          fallback?: string | "uncategorized";
        };
        counts: {
          total: number;
          processed: number;
          created: number;
          updated: number;
          unchanged: number;
          skipped: number;
          failed: number;
          imagesFetched: number;
          imagesFailed: number;
          published: number;
          publishFailed: number;
          publishSkipped: number;
          uncategorized: number;
          stockAdded: number;
        };
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_A_SELLER';
  };
  /** Store the rows of a confirmed import file, read through the seller’s mapping. */
  'catalog.import.load': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      fileEtag: string;
      rows: Array<{
        line: number;
        sourceId: string;
        fields: Record<string, string>;
        imageUrls: string[];
        variants?: Array<{
          line: number;
          fields: Record<string, string>;
        }>;
      }>;
      refused?: Array<{
        line: number;
        problems: Array<{
          code: string;
          message: string;
          severity: "error" | "warning";
          line?: number;
          column?: string;
        }>;
      }>;
      done: boolean;
    };
    output: {
      status: "awaiting_upload" | "queued" | "verifying" | "rejected" | "awaiting_confirmation" | "importing" | "fetching_images" | "imported" | "publishing" | "published" | "expired";
      stored: number;
      batches?: Array<{
        from: number;
        to: number;
      }>;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'IMPORT_NOT_FOUND' | 'IMPORT_NOT_CONFIRMED' | 'FILE_CHANGED';
  };
  /** Record an import file’s structural check and its suggested column mapping. */
  'catalog.import.propose': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      fileEtag: string;
      report: {
        ok: boolean;
        encoding?: "utf-8" | "utf-8-bom";
        bytes: number;
        rowCount: number;
        errors: Array<{
          code: string;
          message: string;
          severity: "error" | "warning";
          line?: number;
          column?: string;
        }>;
        warnings: Array<{
          code: string;
          message: string;
          severity: "error" | "warning";
          line?: number;
          column?: string;
        }>;
      };
      proposal?: {
        rowCount: number;
        productCount: number;
        format?: "going-once" | "whatnot" | "shopify";
        formatSource: "requested" | "detected" | "none";
        fromSavedProfile: boolean;
        columns: Array<{
          index: number;
          header: string;
          samples: string[];
          suggested: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
          confidence: number;
          distinct?: Array<{
            value: string;
            count: number;
            category?: {
              /** UUID, lowercase canonical form */
              categoryId: string;
              confidence: number;
            };
          }>;
          needsReview: boolean;
          alternatives: Array<{
            target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
            confidence: number;
          }>;
        }>;
        notices: Array<{
          code: string;
          message: string;
          count?: number;
        }>;
      };
      headerSignature?: string;
    };
    output: {
      status: "awaiting_upload" | "queued" | "verifying" | "rejected" | "awaiting_confirmation" | "importing" | "fetching_images" | "imported" | "publishing" | "published" | "expired";
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'IMPORT_NOT_FOUND' | 'INVALID_TRANSITION';
  };
  /** Publish every ready draft a catalog import created. */
  'catalog.import.publish': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
    };
    output: {
      job: {
        /** UUID, lowercase canonical form */
        jobId: string;
        status: "awaiting_upload" | "queued" | "verifying" | "rejected" | "awaiting_confirmation" | "importing" | "fetching_images" | "imported" | "publishing" | "published" | "expired";
        phase: "upload" | "verifying" | "confirm" | "rows" | "images" | "publishing" | "done";
        fileName: string;
        requestedFormat?: "going-once" | "whatnot" | "shopify";
        source?: "csv-going-once" | "csv-whatnot" | "csv-shopify" | "csv-user";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
        stalled: boolean;
        verification?: {
          ok: boolean;
          encoding?: "utf-8" | "utf-8-bom";
          bytes: number;
          rowCount: number;
          errors: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
          warnings: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
        };
        proposal?: {
          rowCount: number;
          productCount: number;
          format?: "going-once" | "whatnot" | "shopify";
          formatSource: "requested" | "detected" | "none";
          fromSavedProfile: boolean;
          columns: Array<{
            index: number;
            header: string;
            samples: string[];
            suggested: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
            confidence: number;
            distinct?: Array<{
              value: string;
              count: number;
              category?: {
                /** UUID, lowercase canonical form */
                categoryId: string;
                confidence: number;
              };
            }>;
            needsReview: boolean;
            alternatives: Array<{
              target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
              confidence: number;
            }>;
          }>;
          notices: Array<{
            code: string;
            message: string;
            count?: number;
          }>;
        };
        mapping?: Array<{
          index: number;
          target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
        }>;
        categories?: {
          values?: Array<{
            value: string;
            category: string | "uncategorized";
          }>;
          fallback?: string | "uncategorized";
        };
        counts: {
          total: number;
          processed: number;
          created: number;
          updated: number;
          unchanged: number;
          skipped: number;
          failed: number;
          imagesFetched: number;
          imagesFailed: number;
          published: number;
          publishFailed: number;
          publishSkipped: number;
          uncategorized: number;
          stockAdded: number;
        };
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'IMPORT_NOT_FOUND' | 'IMPORT_NOT_PUBLISHABLE' | 'IMPORT_IN_PROGRESS' | 'PIPELINE_UNAVAILABLE';
  };
  /** Publish the ready drafts in a range of an import’s rows. */
  'catalog.import.publishrows': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      attempt: number;
      range: {
        from: number;
        to: number;
      };
    };
    output: {
      published: number;
      failed: number;
      skipped: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'IMPORT_NOT_FOUND' | 'IMPORT_NOT_PUBLISHING';
  };
  /** Create or update the listings for a range of an import’s rows. */
  'catalog.import.rows': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      range: {
        from: number;
        to: number;
      };
    };
    output: {
      processed: number;
      created: number;
      updated: number;
      unchanged: number;
      skipped: number;
      failed: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'IMPORT_NOT_FOUND' | 'IMPORT_NOT_IMPORTING';
  };
  /** Open a catalog import and get a presigned URL to upload the CSV to. */
  'catalog.import.start': {
    kind: 'command';
    input: {
      fileName: string;
      sizeBytes: number;
      format?: "going-once" | "whatnot" | "shopify";
    };
    output: {
      /** UUID, lowercase canonical form */
      jobId: string;
      uploadUrl: string;
      contentType: "text/csv";
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      expiresAt: string;
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'UPLOAD_UNAVAILABLE';
  };
  /** Get the progress and per-row results of a catalog import. */
  'catalog.import.status': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      jobId: string;
      rows?: "problems" | "all";
      cursor?: number;
      limit?: number;
    };
    output: {
      job: {
        /** UUID, lowercase canonical form */
        jobId: string;
        status: "awaiting_upload" | "queued" | "verifying" | "rejected" | "awaiting_confirmation" | "importing" | "fetching_images" | "imported" | "publishing" | "published" | "expired";
        phase: "upload" | "verifying" | "confirm" | "rows" | "images" | "publishing" | "done";
        fileName: string;
        requestedFormat?: "going-once" | "whatnot" | "shopify";
        source?: "csv-going-once" | "csv-whatnot" | "csv-shopify" | "csv-user";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
        stalled: boolean;
        verification?: {
          ok: boolean;
          encoding?: "utf-8" | "utf-8-bom";
          bytes: number;
          rowCount: number;
          errors: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
          warnings: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
        };
        proposal?: {
          rowCount: number;
          productCount: number;
          format?: "going-once" | "whatnot" | "shopify";
          formatSource: "requested" | "detected" | "none";
          fromSavedProfile: boolean;
          columns: Array<{
            index: number;
            header: string;
            samples: string[];
            suggested: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
            confidence: number;
            distinct?: Array<{
              value: string;
              count: number;
              category?: {
                /** UUID, lowercase canonical form */
                categoryId: string;
                confidence: number;
              };
            }>;
            needsReview: boolean;
            alternatives: Array<{
              target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
              confidence: number;
            }>;
          }>;
          notices: Array<{
            code: string;
            message: string;
            count?: number;
          }>;
        };
        mapping?: Array<{
          index: number;
          target: "title" | "category" | "description" | "condition" | "brand" | "condition_notes" | "sku" | "sale_type" | "price" | "starting_bid" | "reserve_price" | "buy_now_price" | "quantity" | "images" | "weight" | "skip" | string;
        }>;
        categories?: {
          values?: Array<{
            value: string;
            category: string | "uncategorized";
          }>;
          fallback?: string | "uncategorized";
        };
        counts: {
          total: number;
          processed: number;
          created: number;
          updated: number;
          unchanged: number;
          skipped: number;
          failed: number;
          imagesFetched: number;
          imagesFailed: number;
          published: number;
          publishFailed: number;
          publishSkipped: number;
          uncategorized: number;
          stockAdded: number;
        };
      };
      rows?: {
        items: Array<{
          line: number;
          variantLines?: number[];
          sourceId?: string;
          /** UUID, lowercase canonical form */
          listingId?: string;
          title?: string;
          outcome?: "created" | "updated" | "unchanged" | "skipped" | "failed";
          problems: Array<{
            code: string;
            message: string;
            severity: "error" | "warning";
            line?: number;
            column?: string;
          }>;
          images: Array<{
            url: string;
            outcome: "attached" | "already_attached" | "failed";
            code?: string;
          }>;
          publish?: {
            outcome: "published" | "failed" | "skipped";
            problems: Array<{
              code: string;
              message: string;
              severity: "error" | "warning";
              line?: number;
              column?: string;
            }>;
          };
        }>;
        nextCursor?: number;
      };
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'IMPORT_NOT_FOUND';
  };
  /** Queue a product in a Rapid Mode session to be filled in the background. */
  'catalog.intake.add': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sessionId: string;
      /** UUID, lowercase canonical form */
      listingId: string;
      transcript?: string;
      clientTimings?: Record<string, number>;
    };
    output: {
      item: {
        /** UUID, lowercase canonical form */
        itemId: string;
        /** UUID, lowercase canonical form */
        listingId: string;
        position: number;
        status: "queued" | "processing" | "ready" | "needs_info" | "failed" | "published";
        questions: Array<{
          field: string;
          label: string;
          kind: "choice" | "text" | "price";
          options?: Array<{
            id: string;
            name: string;
          }>;
        }>;
        title: string;
        startPriceCents?: number;
        coverMediaKey?: string;
        /** UUID, lowercase canonical form */
        artifactId?: string;
        error?: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SESSION_NOT_FOUND' | 'ITEM_NOT_FOUND' | 'LISTING_NOT_FOUND' | 'SESSION_FINISHED' | 'NOT_A_DRAFT' | 'NO_PHOTO' | 'SESSION_FULL';
  };
  /** Answer one of a Rapid Mode product’s questions. */
  'catalog.intake.answer': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      itemId: string;
      field: string;
      value: string | number;
    };
    output: {
      item: {
        /** UUID, lowercase canonical form */
        itemId: string;
        /** UUID, lowercase canonical form */
        listingId: string;
        position: number;
        status: "queued" | "processing" | "ready" | "needs_info" | "failed" | "published";
        questions: Array<{
          field: string;
          label: string;
          kind: "choice" | "text" | "price";
          options?: Array<{
            id: string;
            name: string;
          }>;
        }>;
        title: string;
        startPriceCents?: number;
        coverMediaKey?: string;
        /** UUID, lowercase canonical form */
        artifactId?: string;
        error?: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SESSION_NOT_FOUND' | 'ITEM_NOT_FOUND' | 'ANSWER_INVALID' | 'NOT_ANSWERABLE';
  };
  /** Publish a Rapid Mode session’s ready products, as the seller confirmed them. */
  'catalog.intake.confirm': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sessionId: string;
      itemIds?: string[];
    };
    output: {
      published: number;
      needsInfo: string[];
      remaining: number;
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SESSION_NOT_FOUND' | 'ITEM_NOT_FOUND';
  };
  /** Set a Rapid Mode session’s defaults, from what the seller said or chose. */
  'catalog.intake.defaults': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sessionId: string;
      utterance?: string;
      defaults?: {
        condition?: "new" | "like_new" | "good" | "fair" | "poor";
        brand?: string;
        categoryHint?: string;
        startPriceCents?: number;
      };
    };
    output: {
      session: {
        /** UUID, lowercase canonical form */
        sessionId: string;
        status: "open" | "finished";
        defaults: {
          condition?: "new" | "like_new" | "good" | "fair" | "poor";
          brand?: string;
          categoryHint?: string;
          startPriceCents?: number;
        };
        counts: {
          queued: number;
          processing: number;
          ready: number;
          needs_info: number;
          failed: number;
          published: number;
        };
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SESSION_NOT_FOUND' | 'ITEM_NOT_FOUND' | 'SESSION_FINISHED' | 'NOTHING_TO_SET' | 'PREFILL_UNAVAILABLE';
  };
  /** Fill one Rapid Mode product from its photo and what the seller said. */
  'catalog.intake.fill': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      itemId: string;
    };
    output: {
      status: "queued" | "processing" | "ready" | "needs_info" | "failed" | "published";
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ITEM_NOT_FOUND' | 'PREFILL_UNAVAILABLE';
  };
  /** Finish a Rapid Mode session: no more products are added. */
  'catalog.intake.finish': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sessionId: string;
    };
    output: {
      session: {
        /** UUID, lowercase canonical form */
        sessionId: string;
        status: "open" | "finished";
        defaults: {
          condition?: "new" | "like_new" | "good" | "fair" | "poor";
          brand?: string;
          categoryHint?: string;
          startPriceCents?: number;
        };
        counts: {
          queued: number;
          processing: number;
          ready: number;
          needs_info: number;
          failed: number;
          published: number;
        };
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SESSION_NOT_FOUND' | 'ITEM_NOT_FOUND';
  };
  /** Fill a Rapid Mode product again after its background fill failed. */
  'catalog.intake.retry': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      itemId: string;
    };
    output: {
      item: {
        /** UUID, lowercase canonical form */
        itemId: string;
        /** UUID, lowercase canonical form */
        listingId: string;
        position: number;
        status: "queued" | "processing" | "ready" | "needs_info" | "failed" | "published";
        questions: Array<{
          field: string;
          label: string;
          kind: "choice" | "text" | "price";
          options?: Array<{
            id: string;
            name: string;
          }>;
        }>;
        title: string;
        startPriceCents?: number;
        coverMediaKey?: string;
        /** UUID, lowercase canonical form */
        artifactId?: string;
        error?: string;
      };
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SESSION_NOT_FOUND' | 'ITEM_NOT_FOUND' | 'NOT_FAILED';
  };
  /** Start a Rapid Mode session. */
  'catalog.intake.start': {
    kind: 'command';
    input: {
      defaults?: {
        condition?: "new" | "like_new" | "good" | "fair" | "poor";
        brand?: string;
        categoryHint?: string;
        startPriceCents?: number;
      };
    };
    output: {
      session: {
        /** UUID, lowercase canonical form */
        sessionId: string;
        status: "open" | "finished";
        defaults: {
          condition?: "new" | "like_new" | "good" | "fair" | "poor";
          brand?: string;
          categoryHint?: string;
          startPriceCents?: number;
        };
        counts: {
          queued: number;
          processing: number;
          ready: number;
          needs_info: number;
          failed: number;
          published: number;
        };
      };
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'NOT_A_SELLER';
  };
  /** A Rapid Mode session: its counts, and each product with what it still needs. */
  'catalog.intake.status': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      sessionId: string;
    };
    output: {
      session: {
        /** UUID, lowercase canonical form */
        sessionId: string;
        status: "open" | "finished";
        defaults: {
          condition?: "new" | "like_new" | "good" | "fair" | "poor";
          brand?: string;
          categoryHint?: string;
          startPriceCents?: number;
        };
        counts: {
          queued: number;
          processing: number;
          ready: number;
          needs_info: number;
          failed: number;
          published: number;
        };
      };
      items: Array<{
        /** UUID, lowercase canonical form */
        itemId: string;
        /** UUID, lowercase canonical form */
        listingId: string;
        position: number;
        status: "queued" | "processing" | "ready" | "needs_info" | "failed" | "published";
        questions: Array<{
          field: string;
          label: string;
          kind: "choice" | "text" | "price";
          options?: Array<{
            id: string;
            name: string;
          }>;
        }>;
        title: string;
        startPriceCents?: number;
        coverMediaKey?: string;
        /** UUID, lowercase canonical form */
        artifactId?: string;
        error?: string;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SESSION_NOT_FOUND' | 'ITEM_NOT_FOUND';
  };
  /** Add or remove available quantity on a listing. */
  'catalog.inventory.adjust': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      delta: number;
    };
    output: {
      /** UUID, lowercase canonical form */
      listingId: string;
      quantityAvailable: number;
      quantityTotal: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'ZERO_DELTA' | 'INSUFFICIENT_INVENTORY' | 'NOT_ADJUSTABLE';
  };
  /** Archive one of the calling seller’s listings. */
  'catalog.listing.archive': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      version: number;
    };
    output: {
      /** UUID, lowercase canonical form */
      listingId: string;
      archived: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'AT_AUCTION' | 'NOT_ARCHIVABLE' | 'CONCURRENT_UPDATE';
  };
  /** Browse active listings, newest first. */
  'catalog.listing.browse': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      categoryId?: string;
      /** UUID, lowercase canonical form */
      sellerId?: string;
      limit?: number;
      cursor?: string;
    };
    output: {
      listings: Array<{
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        title: string;
        /** UUID, lowercase canonical form */
        categoryId: string;
        condition?: string;
        saleModes: Array<"auction" | "fixed">;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
        /** Money in integer cents (USD) */
        fixedPriceCents?: number;
        coverMediaKey?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        publishedAt?: string;
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'public';
    errors: never;
  };
  /** Create a draft listing. */
  'catalog.listing.create': {
    kind: 'command';
    input: {
      title: string;
      description?: string;
      /** UUID, lowercase canonical form */
      categoryId: string;
      condition?: string;
      brand?: string;
      conditionNotes?: string;
      /** Category-template keys plus up to 10 ad-hoc keys (D10) */
      attributes?: Record<string, string | number | boolean>;
      saleModes?: Array<"auction" | "fixed">;
      /** Money in integer cents (USD) */
      startPriceCents?: number;
      /** Money in integer cents (USD) */
      reserveCents?: number;
      /** Money in integer cents (USD) */
      binCents?: number;
      /** Money in integer cents (USD) */
      fixedPriceCents?: number;
      quantityTotal?: number;
      weightGrams?: number;
      source?: string;
      sourceId?: string;
    };
    output: {
      listing: {
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        title: string;
        description?: string;
        /** UUID, lowercase canonical form */
        categoryId: string;
        categoryPath: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        status: "draft" | "active" | "at_auction" | "sold" | "archived" | "taken_down";
        /** Category-template keys plus up to 10 ad-hoc keys (D10) */
        attributes: Record<string, string | number | boolean>;
        details?: Array<{
          key: string;
          label: string;
          value: string;
        }>;
        saleModes: Array<"auction" | "fixed">;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
        /** Money in integer cents (USD) */
        reserveCents?: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Money in integer cents (USD) */
        fixedPriceCents?: number;
        weightGrams?: number;
        quantityAvailable: number;
        quantityTotal: number;
        mediaKeys: string[];
        version: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
      };
      adHocKeys: string[];
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'CATEGORY_NOT_FOUND' | 'CATEGORY_NOT_LISTABLE' | 'CATEGORY_CLOSED' | 'CATEGORY_UNASSIGNED' | 'CATEGORY_NOT_AVAILABLE' | 'LISTING_INVALID' | 'DUPLICATE_SOURCE_REF' | 'SOURCE_REF_INCOMPLETE';
  };
  /** Page through every listing that has been on sale, for a search rebuild. */
  'catalog.listing.export': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      after?: string;
      limit?: number;
    };
    output: {
      listings: Array<{
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        /** UUID, lowercase canonical form */
        categoryId: string;
        categoryPath: string;
        title: string;
        description?: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        attributes: Record<string, string | number | boolean>;
        saleModes: Array<"auction" | "fixed">;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Money in integer cents (USD) */
        fixedPriceCents?: number;
        quantityAvailable: number;
        inventoryVersion?: number;
        mediaKeys: string[];
        coverMediaKey?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        publishedAt: string;
        searchVersion: number;
        listingVersion: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        occurredAt: string;
      }>;
      withdrawn: Array<{
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        listingVersion: number;
      }>;
      /** UUID, lowercase canonical form */
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: never;
  };
  /** Fetch a listing by id. */
  'catalog.listing.get': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
    };
    output: {
      listing: {
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        title: string;
        description?: string;
        /** UUID, lowercase canonical form */
        categoryId: string;
        categoryPath: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        status: "draft" | "active" | "at_auction" | "sold" | "archived" | "taken_down";
        /** Category-template keys plus up to 10 ad-hoc keys (D10) */
        attributes: Record<string, string | number | boolean>;
        details?: Array<{
          key: string;
          label: string;
          value: string;
        }>;
        saleModes: Array<"auction" | "fixed">;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
        /** Money in integer cents (USD) */
        reserveCents?: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Money in integer cents (USD) */
        fixedPriceCents?: number;
        weightGrams?: number;
        quantityAvailable: number;
        quantityTotal: number;
        mediaKeys: string[];
        version: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
      };
    };
    idempotency: 'none';
    access: 'public';
    errors: 'LISTING_NOT_FOUND';
  };
  /** Name the product in a photo ahead of the suggestion, so the seller does not wait for it. */
  'catalog.listing.identify': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      image: string;
      transcript?: string;
      mode?: "smart" | "voice";
    };
    output: {
      /** UUID, lowercase canonical form */
      identifiedId: string;
      productType: string;
      alternatives: string[];
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'INVALID_IMAGE' | 'PREFILL_UNAVAILABLE';
  };
  /** List the calling seller’s own listings, newest first. */
  'catalog.listing.list': {
    kind: 'query';
    input: {
      status?: "draft" | "active" | "at_auction" | "sold" | "archived" | "taken_down";
      limit?: number;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      cursor?: string;
    };
    output: {
      listings: Array<{
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        title: string;
        description?: string;
        /** UUID, lowercase canonical form */
        categoryId: string;
        categoryPath: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        status: "draft" | "active" | "at_auction" | "sold" | "archived" | "taken_down";
        /** Category-template keys plus up to 10 ad-hoc keys (D10) */
        attributes: Record<string, string | number | boolean>;
        details?: Array<{
          key: string;
          label: string;
          value: string;
        }>;
        saleModes: Array<"auction" | "fixed">;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
        /** Money in integer cents (USD) */
        reserveCents?: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Money in integer cents (USD) */
        fixedPriceCents?: number;
        weightGrams?: number;
        quantityAvailable: number;
        quantityTotal: number;
        mediaKeys: string[];
        version: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
      }>;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_A_SELLER';
  };
  /** Suggest listing fields from the listing’s photo and the seller’s spoken description. */
  'catalog.listing.prefill': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      /** UUID, lowercase canonical form */
      mediaId?: string;
      sellerNote?: string;
      transcript?: string;
      defaults?: {
        condition?: "new" | "like_new" | "good" | "fair" | "poor";
        brand?: string;
        categoryHint?: string;
        startPriceCents?: number;
      };
      mode?: "smart" | "voice" | "rapid";
      clientTimings?: Record<string, number>;
      /** UUID, lowercase canonical form */
      identified?: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      artifactId: string;
      suggestion: {
        title?: string;
        /** UUID, lowercase canonical form */
        categoryId?: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        attributes?: Record<string, string | number | boolean>;
        suggestedStartPriceCents?: number;
      };
      fields: Record<string, {
        confidence: number;
        source: "photo" | "voice" | "both" | "default";
      }>;
      questions: Array<{
        field: string;
        label: string;
        kind: "choice" | "text" | "price";
        options?: Array<{
          id: string;
          name: string;
        }>;
      }>;
      confidence: number;
      withheld: string[];
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'NO_PHOTO' | 'MEDIA_NOT_FOUND' | 'PREFILL_UNAVAILABLE';
  };
  /** Publish a draft listing so buyers can see it. */
  'catalog.listing.publish': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      version: number;
    };
    output: {
      listing: {
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        title: string;
        description?: string;
        /** UUID, lowercase canonical form */
        categoryId: string;
        categoryPath: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        status: "draft" | "active" | "at_auction" | "sold" | "archived" | "taken_down";
        /** Category-template keys plus up to 10 ad-hoc keys (D10) */
        attributes: Record<string, string | number | boolean>;
        details?: Array<{
          key: string;
          label: string;
          value: string;
        }>;
        saleModes: Array<"auction" | "fixed">;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
        /** Money in integer cents (USD) */
        reserveCents?: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Money in integer cents (USD) */
        fixedPriceCents?: number;
        weightGrams?: number;
        quantityAvailable: number;
        quantityTotal: number;
        mediaKeys: string[];
        version: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'CATEGORY_NOT_FOUND' | 'CATEGORY_NOT_LISTABLE' | 'CATEGORY_CLOSED' | 'CATEGORY_UNASSIGNED' | 'CATEGORY_NOT_AVAILABLE' | 'LISTING_INVALID' | 'NOT_PUBLISHABLE' | 'CONCURRENT_UPDATE' | 'NO_INVENTORY';
  };
  /** Create and immediately publish a listing (Live List). */
  'catalog.listing.quickcreate': {
    kind: 'command';
    input: {
      title: string;
      /** UUID, lowercase canonical form */
      categoryId: string;
      /** Category-template keys plus up to 10 ad-hoc keys (D10) */
      attributes?: Record<string, string | number | boolean>;
      saleModes: Array<"auction" | "fixed">;
      /** Money in integer cents (USD) */
      startPriceCents?: number;
      /** Money in integer cents (USD) */
      reserveCents?: number;
      /** Money in integer cents (USD) */
      binCents?: number;
      /** Money in integer cents (USD) */
      fixedPriceCents?: number;
      quantityTotal?: number;
      condition?: string;
      brand?: string;
      conditionNotes?: string;
    };
    output: {
      listing: {
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        title: string;
        description?: string;
        /** UUID, lowercase canonical form */
        categoryId: string;
        categoryPath: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        status: "draft" | "active" | "at_auction" | "sold" | "archived" | "taken_down";
        /** Category-template keys plus up to 10 ad-hoc keys (D10) */
        attributes: Record<string, string | number | boolean>;
        details?: Array<{
          key: string;
          label: string;
          value: string;
        }>;
        saleModes: Array<"auction" | "fixed">;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
        /** Money in integer cents (USD) */
        reserveCents?: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Money in integer cents (USD) */
        fixedPriceCents?: number;
        weightGrams?: number;
        quantityAvailable: number;
        quantityTotal: number;
        mediaKeys: string[];
        version: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'CATEGORY_NOT_FOUND' | 'CATEGORY_NOT_LISTABLE' | 'CATEGORY_CLOSED' | 'CATEGORY_UNASSIGNED' | 'CATEGORY_NOT_AVAILABLE' | 'LISTING_INVALID';
  };
  /** Apply a spoken correction to a suggestion: "make that a large instead". */
  'catalog.listing.revise': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      /** UUID, lowercase canonical form */
      artifactId: string;
      utterance: string;
      current: {
        title?: string;
        /** UUID, lowercase canonical form */
        categoryId?: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        attributes?: Record<string, string | number | boolean>;
        suggestedStartPriceCents?: number;
      };
    };
    output: {
      /** UUID, lowercase canonical form */
      artifactId: string;
      suggestion: {
        title?: string;
        /** UUID, lowercase canonical form */
        categoryId?: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        attributes?: Record<string, string | number | boolean>;
        suggestedStartPriceCents?: number;
      };
      changed: string[];
      withheld: string[];
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'ARTIFACT_NOT_FOUND' | 'PREFILL_UNAVAILABLE';
  };
  /** Remove a listing from the platform (staff). */
  'catalog.listing.takedown': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      /** Travels on the event and into the T&S case */
      reason: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      listingId: string;
      previousStatus: string;
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'LISTING_NOT_FOUND' | 'ALREADY_TAKEN_DOWN' | 'CONCURRENT_UPDATE';
  };
  /** Update a listing’s fields, attributes or pricing. */
  'catalog.listing.update': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      version: number;
      title?: string;
      description?: string;
      /** UUID, lowercase canonical form */
      categoryId?: string;
      condition?: string;
      brand?: string | null;
      conditionNotes?: string;
      /** Category-template keys plus up to 10 ad-hoc keys (D10) */
      attributes?: Record<string, string | number | boolean>;
      saleModes?: Array<"auction" | "fixed">;
      /** Money in integer cents (USD) */
      startPriceCents?: number;
      /** Money in integer cents (USD) */
      reserveCents?: number;
      /** Money in integer cents (USD) */
      binCents?: number;
      /** Money in integer cents (USD) */
      fixedPriceCents?: number;
      weightGrams?: number | null;
      /** UUID, lowercase canonical form */
      fromPrefill?: string;
      clientTimings?: Record<string, number>;
    };
    output: {
      listing: {
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        title: string;
        description?: string;
        /** UUID, lowercase canonical form */
        categoryId: string;
        categoryPath: string;
        condition?: string;
        brand?: string;
        conditionNotes?: string;
        status: "draft" | "active" | "at_auction" | "sold" | "archived" | "taken_down";
        /** Category-template keys plus up to 10 ad-hoc keys (D10) */
        attributes: Record<string, string | number | boolean>;
        details?: Array<{
          key: string;
          label: string;
          value: string;
        }>;
        saleModes: Array<"auction" | "fixed">;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
        /** Money in integer cents (USD) */
        reserveCents?: number;
        /** Money in integer cents (USD) */
        binCents?: number;
        /** Money in integer cents (USD) */
        fixedPriceCents?: number;
        weightGrams?: number;
        quantityAvailable: number;
        quantityTotal: number;
        mediaKeys: string[];
        version: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        updatedAt: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'CATEGORY_NOT_FOUND' | 'CATEGORY_NOT_LISTABLE' | 'CATEGORY_CLOSED' | 'CATEGORY_UNASSIGNED' | 'CATEGORY_NOT_AVAILABLE' | 'LISTING_INVALID' | 'NOT_EDITABLE' | 'CONCURRENT_UPDATE';
  };
  /** Attach an uploaded image or video to a listing. */
  'catalog.media.attach': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      s3Key: string;
      kind?: "image" | "video";
      position?: number;
      aiGenerated?: boolean;
    };
    output: {
      /** UUID, lowercase canonical form */
      mediaId: string;
      position: number;
      moderationState: "pending";
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'TOO_MUCH_MEDIA' | 'UNKNOWN_MEDIA_KEY' | 'NOT_EDITABLE' | 'CONCURRENT_UPDATE';
  };
  /** Get a presigned URL for uploading a listing photo. */
  'catalog.media.presign': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      contentType: "image/jpeg" | "image/png" | "image/webp" | "image/heic";
      sizeBytes: number;
    };
    output: {
      key: string;
      uploadUrl: string;
      contentType: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      expiresAt: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'NOT_EDITABLE' | 'TOO_MUCH_MEDIA' | 'UPLOAD_UNAVAILABLE';
  };
  /** Remove photos or videos from one of the calling seller’s listings. */
  'catalog.media.remove': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      s3Keys: string[];
    };
    output: {
      removed: number;
      mediaKeys: string[];
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'UNKNOWN_MEDIA_KEY' | 'LAST_PHOTO' | 'NOT_EDITABLE' | 'CONCURRENT_UPDATE';
  };
  /** Set the order of the photos and videos on one of the calling seller’s listings. */
  'catalog.media.reorder': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      s3Keys: string[];
    };
    output: {
      mediaKeys: string[];
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'MEDIA_MISMATCH' | 'NOT_EDITABLE' | 'CONCURRENT_UPDATE';
  };
  /** List the taxonomy update review queue (staff). */
  'catalog.taxonomy.changes': {
    kind: 'query';
    input: {
      review?: "open" | "approved" | "rejected";
      entityRef?: string;
      after?: string;
      limit?: number;
    };
    output: {
      changes: Array<{
        /** UUID, lowercase canonical form */
        changeId: string;
        version: string;
        entityType: "category" | "attribute" | "value";
        entityRef: string;
        kind: "added" | "renamed" | "moved" | "values_changed" | "removed";
        before?: Record<string, unknown>;
        after?: Record<string, unknown>;
        review: "open" | "approved" | "rejected";
        decidedBy?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        decidedAt?: string;
        note?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      }>;
      next?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: never;
  };
  /** List one category’s children with status counts (staff). */
  'catalog.taxonomy.children': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      parentId?: string;
    };
    output: {
      nodes: Array<{
        category: {
          /** UUID, lowercase canonical form */
          categoryId: string;
          /** UUID, lowercase canonical form */
          parentId?: string;
          shopifyId: string;
          name: string;
          fullName: string;
          level: number;
          listable: boolean;
          placeholder: boolean;
          goStatus: "SHOW" | "HIDE" | "PENDING";
          statusFrom: "own" | "inherited" | "default";
          brandRequired: boolean;
          rule?: {
            status?: "SHOW" | "HIDE" | "PENDING";
            brandRequired?: boolean;
            reason?: string;
            updatedBy?: string;
          };
          addedIn: string;
          removedIn?: string;
        };
        childCount: number;
        subtree: {
          SHOW: number;
          HIDE: number;
          PENDING: number;
        };
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: never;
  };
  /** Approve or reject a taxonomy update (staff). */
  'catalog.taxonomy.decide': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      changeId: string;
      decision: "approved" | "rejected";
      note?: string;
    };
    output: {
      change: {
        /** UUID, lowercase canonical form */
        changeId: string;
        version: string;
        entityType: "category" | "attribute" | "value";
        entityRef: string;
        kind: "added" | "renamed" | "moved" | "values_changed" | "removed";
        before?: Record<string, unknown>;
        after?: Record<string, unknown>;
        review: "open" | "approved" | "rejected";
        decidedBy?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        decidedAt?: string;
        note?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      };
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'CHANGE_NOT_FOUND' | 'CHANGE_ALREADY_DECIDED';
  };
  /** Fetch the category tree, attribute dictionary and per-category templates. */
  'catalog.taxonomy.get': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      categories: Array<{
        /** UUID, lowercase canonical form */
        categoryId: string;
        /** UUID, lowercase canonical form */
        parentId?: string;
        slug: string;
        name: string;
        path: string;
        listable: boolean;
        authenticationRequired: boolean;
        brandRequired: boolean;
      }>;
      attributes: Array<{
        key: string;
        label: string;
        dataType: "string" | "integer" | "decimal" | "enum" | "boolean" | "date";
        unit?: string;
        options?: Array<{
          /** UUID, lowercase canonical form */
          id: string;
          name: string;
        }>;
        validation?: {
          min?: number;
          max?: number;
          pattern?: string;
          maxLength?: number;
        };
        facetable: boolean;
      }>;
      templates: Array<{
        /** UUID, lowercase canonical form */
        categoryId: string;
        entries: Array<{
          key: string;
          required: boolean;
          variantEligible: boolean;
          displayOrder: number;
          inputType?: "list" | "free_text";
        }>;
      }>;
    };
    idempotency: 'none';
    access: 'public';
    errors: never;
  };
  /** Read one category with its form, rules, listings count and open changes (staff). */
  'catalog.taxonomy.inspect': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      categoryId: string;
    };
    output: {
      category: {
        /** UUID, lowercase canonical form */
        categoryId: string;
        /** UUID, lowercase canonical form */
        parentId?: string;
        shopifyId: string;
        name: string;
        fullName: string;
        level: number;
        listable: boolean;
        placeholder: boolean;
        goStatus: "SHOW" | "HIDE" | "PENDING";
        statusFrom: "own" | "inherited" | "default";
        brandRequired: boolean;
        rule?: {
          status?: "SHOW" | "HIDE" | "PENDING";
          brandRequired?: boolean;
          reason?: string;
          updatedBy?: string;
        };
        addedIn: string;
        removedIn?: string;
      };
      attributes: Array<{
        attribute: {
          /** UUID, lowercase canonical form */
          attributeId: string;
          shopifyId: string;
          handle: string;
          name: string;
          description?: string;
          goStatus: "SHOW" | "HIDE" | "PENDING";
          inputType: "list" | "free_text";
          removedIn?: string;
          values?: Array<{
            /** UUID, lowercase canonical form */
            valueId: string;
            shopifyId: string;
            name: string;
            goStatus: "SHOW" | "HIDE" | "PENDING";
            removedIn?: string;
          }>;
        };
        fromShopify: boolean;
        onForm: boolean;
        required: boolean;
        variantEligible: boolean;
        displayOrder: number;
        inputType: "list" | "free_text";
        rule?: {
          required?: boolean;
          variantEligible?: boolean;
          displayOrder?: number;
          removed?: boolean;
          inputType?: "list" | "free_text";
        };
      }>;
      listingCount: number;
      openChanges: Array<{
        /** UUID, lowercase canonical form */
        changeId: string;
        version: string;
        entityType: "category" | "attribute" | "value";
        entityRef: string;
        kind: "added" | "renamed" | "moved" | "values_changed" | "removed";
        before?: Record<string, unknown>;
        after?: Record<string, unknown>;
        review: "open" | "approved" | "rejected";
        decidedBy?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        decidedAt?: string;
        note?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'CATEGORY_NOT_FOUND';
  };
  /** Search categories or attributes by name (staff). */
  'catalog.taxonomy.search': {
    kind: 'query';
    input: {
      entity: "category" | "attribute";
      text: string;
      status?: "SHOW" | "HIDE" | "PENDING";
      limit?: number;
    };
    output: {
      categories?: Array<{
        /** UUID, lowercase canonical form */
        categoryId: string;
        /** UUID, lowercase canonical form */
        parentId?: string;
        shopifyId: string;
        name: string;
        fullName: string;
        level: number;
        listable: boolean;
        placeholder: boolean;
        goStatus: "SHOW" | "HIDE" | "PENDING";
        statusFrom: "own" | "inherited" | "default";
        brandRequired: boolean;
        rule?: {
          status?: "SHOW" | "HIDE" | "PENDING";
          brandRequired?: boolean;
          reason?: string;
          updatedBy?: string;
        };
        addedIn: string;
        removedIn?: string;
      }>;
      attributes?: Array<{
        /** UUID, lowercase canonical form */
        attributeId: string;
        shopifyId: string;
        handle: string;
        name: string;
        description?: string;
        goStatus: "SHOW" | "HIDE" | "PENDING";
        inputType: "list" | "free_text";
        removedIn?: string;
        values?: Array<{
          /** UUID, lowercase canonical form */
          valueId: string;
          shopifyId: string;
          name: string;
          goStatus: "SHOW" | "HIDE" | "PENDING";
          removedIn?: string;
        }>;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: never;
  };
  /** Set or clear a category or attribute rule (staff). */
  'catalog.taxonomy.setrule': {
    kind: 'command';
    input: {
      kind: "category";
      /** UUID, lowercase canonical form */
      categoryId: string;
      brandRequired?: boolean | null;
    } | {
      kind: "categoryAttribute";
      /** UUID, lowercase canonical form */
      categoryId: string;
      /** UUID, lowercase canonical form */
      attributeId: string;
      required?: boolean | null;
      variantEligible?: boolean | null;
      displayOrder?: number | null;
      removed?: boolean | null;
      inputType?: "list" | "free_text" | null;
    } | {
      kind: "attribute";
      /** UUID, lowercase canonical form */
      attributeId: string;
      inputType?: "free_text" | null;
    };
    output: {
      saved: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'CATEGORY_NOT_FOUND' | 'ATTRIBUTE_NOT_FOUND';
  };
  /** Set categories, attributes or values to SHOW, HIDE or PENDING (staff). */
  'catalog.taxonomy.setstatus': {
    kind: 'command';
    input: {
      entity: "category" | "attribute" | "value";
      ids: string[];
      status: "SHOW" | "HIDE" | "PENDING" | "inherit";
    };
    output: {
      updated: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'CATEGORY_NOT_FOUND' | 'ATTRIBUTE_NOT_FOUND' | 'VALUE_NOT_FOUND';
  };
  /** Replace a listing’s variant set. */
  'catalog.variant.set': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      listingId: string;
      variants: Array<{
        /** Category-template keys plus up to 10 ad-hoc keys (D10) */
        attributeValues: Record<string, string | number | boolean>;
        sku?: string;
        quantityAvailable: number;
        priceDeltaCents?: number;
      }>;
    };
    output: {
      variants: Array<{
        /** UUID, lowercase canonical form */
        variantId: string;
        /** Category-template keys plus up to 10 ad-hoc keys (D10) */
        attributeValues: Record<string, string | number | boolean>;
        sku?: string;
        quantityAvailable: number;
        priceDeltaCents: number;
      }>;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'LISTING_NOT_FOUND' | 'CATEGORY_NOT_FOUND' | 'CATEGORY_NOT_LISTABLE' | 'CATEGORY_CLOSED' | 'CATEGORY_UNASSIGNED' | 'CATEGORY_NOT_AVAILABLE' | 'LISTING_INVALID' | 'NOT_VARIANT_ELIGIBLE' | 'DUPLICATE_VARIANT' | 'NOT_EDITABLE' | 'EMPTY_VARIANT';
  };
  /** Browse listings on sale, newest first. */
  'discovery.listing.browse': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      categoryId?: string;
      /** UUID, lowercase canonical form */
      sellerId?: string;
      limit?: number;
      cursor?: string;
    };
    output: {
      listings: Array<{
        /** UUID, lowercase canonical form */
        listingId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        title: string;
        /** UUID, lowercase canonical form */
        categoryId: string;
        condition?: string;
        saleModes: Array<"auction" | "fixed">;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
        /** Money in integer cents (USD) */
        fixedPriceCents?: number;
        coverMediaKey?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        publishedAt?: string;
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'public';
    errors: 'SEARCH_UNAVAILABLE';
  };
  /** Apply one listing event to the browse projection. */
  'discovery.listing.record': {
    kind: 'command';
    input: {
      event: string;
      payload: Record<string, unknown>;
    };
    output: {
      outcome: "written" | "stale" | "ignored";
      reason?: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'EVENT_CONTRACT_MISMATCH';
  };
  /** Confirm that a notification reached the device, with the token its push carried. */
  'discovery.notification.confirmReceipt': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      notificationId: string;
      receiptToken: string;
    };
    output: {
      ok: true;
    };
    idempotency: 'natural';
    access: 'public';
    errors: never;
  };
  /** Count the caller's unread notifications. */
  'discovery.notification.count': {
    kind: 'query';
    input: {
      audience?: "buyer" | "seller";
    };
    output: {
      unread: number;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** Get a presigned URL for uploading a notification’s image (staff). */
  'discovery.notification.imageUpload': {
    kind: 'command';
    input: {
      contentType: "image/jpeg" | "image/png";
      sizeBytes: number;
    };
    output: {
      key: string;
      uploadUrl: string;
      contentType: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      expiresAt: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'UPLOAD_UNAVAILABLE';
  };
  /** Page through the caller's notifications, newest first. */
  'discovery.notification.list': {
    kind: 'query';
    input: {
      limit?: number;
      audience?: "buyer" | "seller";
      cursor?: string;
    };
    output: {
      notifications: Array<{
        /** UUID, lowercase canonical form */
        notificationId: string;
        audience: "buyer" | "seller";
        /** A short word for the icon: `outbid`, `won`, `payment_failed` */
        kind: string;
        category: "order_receipts" | "account_alerts" | "shipping_updates" | "outbid_alerts" | "live_reminders" | "messages" | "news_offers" | "recommendations";
        title: string;
        body: string;
        /** An in-app path the row opens, never a URL */
        link?: string;
        imageKey?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        read: boolean;
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'INVALID_CURSOR';
  };
  /** Mark some or all of the caller's notifications read. */
  'discovery.notification.markRead': {
    kind: 'command';
    input: {
      notificationIds?: string[];
      all?: true;
      audience?: "buyer" | "seller";
    };
    output: {
      unread: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'INVALID_SELECTION';
  };
  /** Record that this device received one or more of the caller’s notifications. */
  'discovery.notification.markReceived': {
    kind: 'command';
    input: {
      notificationIds: string[];
    };
    output: {
      recorded: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** Send one user a notification and push it to their devices (staff). */
  'discovery.notification.send': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
      audience: "buyer" | "seller";
      category: "order_receipts" | "account_alerts" | "shipping_updates" | "outbid_alerts" | "live_reminders" | "messages" | "news_offers" | "recommendations";
      title: string;
      body: string;
      /** An in-app path starting with a single slash, never a URL */
      link?: string;
      /** The key discovery.notification.imageUpload returned, once the upload has succeeded */
      imageKey?: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      notificationId: string;
      /** Devices with a live push endpoint */
      devices: number;
      delivered: number;
      /** Devices a gateway has disabled */
      unreachable: number;
      /** The person turned push off for this category, so nothing was pushed. It is still in their center. */
      pushSuppressed: boolean;
      failed: number;
      failures: string[];
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'USER_NOT_FOUND' | 'IMAGE_UNAVAILABLE';
  };
  /** The caller's notification preferences, per category and channel. */
  'discovery.notifprefs.get': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      categories: Array<{
        category: "order_receipts" | "account_alerts" | "shipping_updates" | "outbid_alerts" | "live_reminders" | "messages" | "news_offers" | "recommendations";
        label: string;
        description: string;
        push: boolean;
        email: boolean;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** Turn push or email on or off for one notification category. */
  'discovery.notifprefs.set': {
    kind: 'command';
    input: {
      category: "order_receipts" | "account_alerts" | "shipping_updates" | "outbid_alerts" | "live_reminders" | "messages" | "news_offers" | "recommendations";
      channel: "push" | "email";
      enabled: boolean;
    };
    output: {
      category: "order_receipts" | "account_alerts" | "shipping_updates" | "outbid_alerts" | "live_reminders" | "messages" | "news_offers" | "recommendations";
      channel: "push" | "email";
      enabled: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** Create the GO user record for a newly confirmed Cognito identity. */
  'identity.account.create': {
    kind: 'command';
    input: {
      /** Cognito sub — the principal id for shoppers */
      cognitoSub: string;
      displayName: string;
      provider: "apple" | "google" | "facebook" | "password";
      providerSubject: string;
      email?: string;
      emailVerified: boolean;
      /** Apple private relay — excluded from email auto-link (D3) */
      isPrivateRelayEmail: boolean;
      avatarUrl?: string;
      locale?: string;
      country?: string;
    };
    output: {
      profile: {
        /** UUID, lowercase canonical form */
        userId: string;
        /** Public handle: lowercase letters, digits and underscores, 3–30 chars, no leading/trailing underscore */
        handle?: string;
        displayName: string;
        avatarUrl?: string;
        email?: string;
        emailVerified: boolean;
        status: "active" | "restricted" | "banned";
        locale?: string;
        country?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      };
      created: boolean;
      /** UUID, lowercase canonical form */
      userId: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'AUTH_METHOD_ALREADY_LINKED';
  };
  /** Get the display names and masked emails of up to 50 accounts by user id (staff). */
  'identity.account.names': {
    kind: 'query';
    input: {
      userIds: string[];
    };
    output: {
      accounts: Array<{
        /** UUID, lowercase canonical form */
        userId: string;
        displayName: string;
        /** The email masked by the server: the first character, then •••@ and the domain. Never the address. */
        maskedEmail?: string;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_IMPLEMENTED';
  };
  /** Return a restricted or banned account to active (staff). */
  'identity.account.restore': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
      /** Why the account is being restored */
      reason: string;
    };
    output: {
      profile: {
        /** UUID, lowercase canonical form */
        userId: string;
        /** Public handle: lowercase letters, digits and underscores, 3–30 chars, no leading/trailing underscore */
        handle?: string;
        displayName: string;
        avatarUrl?: string;
        email?: string;
        emailVerified: boolean;
        status: "active" | "restricted" | "banned";
        locale?: string;
        country?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      };
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'USER_NOT_FOUND' | 'ALREADY_ACTIVE' | 'CONCURRENT_UPDATE';
  };
  /** Find user accounts by email, handle, display name or id (staff). */
  'identity.account.search': {
    kind: 'query';
    input: {
      by: "email" | "handle" | "name" | "userId";
      q: string;
      limit?: number;
    };
    output: {
      accounts: Array<{
        /** UUID, lowercase canonical form */
        userId: string;
        /** Public handle: lowercase letters, digits and underscores, 3–30 chars, no leading/trailing underscore */
        handle?: string;
        displayName: string;
        avatarUrl?: string;
        /** Returned in full today; masked (u•••@domain: the first character, then •••@ and the domain) once the masking handler lands (GO-613). identity.email.reveal returns the whole address. */
        email?: string;
        emailVerified: boolean;
        isPrivateRelayEmail: boolean;
        status: "active" | "restricted" | "banned";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      }>;
      truncated: boolean;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'INVALID_QUERY';
  };
  /** Log a user out of every device (staff). */
  'identity.account.signout': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
      /** The reason picked in the console. Kept with the operation and the audit record; on no event. */
      reason: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      userId: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      sessionsEndedAt: string;
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'USER_NOT_FOUND' | 'SIGNOUT_OUTCOME_UNKNOWN' | 'NOT_IMPLEMENTED';
  };
  /** Restrict or ban a user account (staff). */
  'identity.account.suspend': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
      status: "restricted" | "banned";
      /** Travels on the event and into the T&S timeline */
      reason: string;
    };
    output: {
      profile: {
        /** UUID, lowercase canonical form */
        userId: string;
        /** Public handle: lowercase letters, digits and underscores, 3–30 chars, no leading/trailing underscore */
        handle?: string;
        displayName: string;
        avatarUrl?: string;
        email?: string;
        emailVerified: boolean;
        status: "active" | "restricted" | "banned";
        locale?: string;
        country?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      };
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'USER_NOT_FOUND' | 'ALREADY_IN_STATUS' | 'CONCURRENT_UPDATE';
  };
  /** Link an additional sign-in provider to the caller's account. */
  'identity.authmethod.link': {
    kind: 'command';
    input: {
      provider: "apple" | "google" | "facebook" | "password";
      /** Subject from the verified provider assertion — supplied by the adapter, not the client */
      providerSubject: string;
    };
    output: {
      method: {
        provider: "apple" | "google" | "facebook" | "password";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        linkedAt: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'AUTH_METHOD_ALREADY_LINKED';
  };
  /** List the sign-in methods linked to the caller's account. */
  'identity.authmethod.list': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      methods: Array<{
        provider: "apple" | "google" | "facebook" | "password";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        linkedAt: string;
      }>;
      canUnlink: boolean;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** Remove a sign-in provider from the caller's account. */
  'identity.authmethod.unlink': {
    kind: 'command';
    input: {
      provider: "apple" | "google" | "facebook" | "password";
    };
    output: {
      remainingMethods: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'METHOD_NOT_LINKED' | 'LAST_AUTH_METHOD';
  };
  /** Record a buyer’s consent to share email and purchase history with one seller. */
  'identity.consent.grant': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      scope: "email_purchase_history";
      /** The disclosure version the client rendered; the server hashes its own copy of that text */
      disclosureVersion: string;
      source: "first_bid_in_show";
      /** UUID, lowercase canonical form */
      showId?: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      grantId: string;
      created: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'UNKNOWN_DISCLOSURE_VERSION';
  };
  /** List the caller's current data-sharing consents, per seller. */
  'identity.consent.list': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      consents: Array<{
        /** UUID, lowercase canonical form */
        grantId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        scope: "email_purchase_history";
        state: "granted" | "revoked";
        disclosureVersion: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        occurredAt: string;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** Revoke a data-sharing consent the caller previously granted to a seller. */
  'identity.consent.revoke': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      scope: "email_purchase_history";
    };
    output: {
      /** UUID, lowercase canonical form */
      grantId: string;
      revoked: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NO_SUCH_GRANT';
  };
  /** Reveal an account’s full email address to staff, logged with a reason. */
  'identity.email.reveal': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
    };
    output: {
      email?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_IMPLEMENTED';
  };
  /** Replace the caller's interest selections and optional free-text note. */
  'identity.interests.set': {
    kind: 'command';
    input: {
      /** Complete selection, not a delta */
      categoryIds: string[];
      /** Free-text intent, carried verbatim to Discovery */
      note?: string;
      source: "onboarding" | "settings";
    };
    output: {
      categoryCount: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** Fetch the signed-in caller's own profile. */
  'identity.profile.get': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      profile: {
        /** UUID, lowercase canonical form */
        userId: string;
        /** Public handle: lowercase letters, digits and underscores, 3–30 chars, no leading/trailing underscore */
        handle?: string;
        displayName: string;
        avatarUrl?: string;
        email?: string;
        emailVerified: boolean;
        status: "active" | "restricted" | "banned";
        locale?: string;
        country?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      };
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** Update the caller's own handle, display name, avatar or locale. */
  'identity.profile.update': {
    kind: 'command';
    input: {
      /** Public handle: lowercase letters, digits and underscores, 3–30 chars, no leading/trailing underscore */
      handle?: string;
      displayName?: string;
      avatarUrl?: string;
      locale?: string;
      country?: string;
    };
    output: {
      profile: {
        /** UUID, lowercase canonical form */
        userId: string;
        /** Public handle: lowercase letters, digits and underscores, 3–30 chars, no leading/trailing underscore */
        handle?: string;
        displayName: string;
        avatarUrl?: string;
        email?: string;
        emailVerified: boolean;
        status: "active" | "restricted" | "banned";
        locale?: string;
        country?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'HANDLE_TAKEN' | 'HANDLE_RESERVED' | 'HANDLE_IMMUTABLE' | 'CONCURRENT_UPDATE' | 'NOTHING_TO_UPDATE';
  };
  /** List the push-capable devices registered to one account (staff). */
  'identity.pushtoken.list': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
    };
    output: {
      tokens: Array<{
        /** UUID, lowercase canonical form */
        tokenId: string;
        platform: "ios" | "android";
        maskedDeviceId: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        lastSeenAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        revokedAt?: string;
      }>;
      truncated: boolean;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_IMPLEMENTED';
  };
  /** Record this device's push token for the caller. */
  'identity.pushtoken.register': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      deviceId: string;
      platform: "ios" | "android";
      /** The raw APNs or FCM device token */
      token: string;
      /** iOS only: the APNs gateway this token belongs to (`development` is the sandbox) */
      apnsEnvironment?: "development" | "production";
    };
    output: {
      /** UUID, lowercase canonical form */
      tokenId: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'APNS_ENVIRONMENT_MISMATCH';
  };
  /** Show the commission rate the pricing resolver would charge a seller now (staff). */
  'orders.commission.preview': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      at: string;
      resolverVersion: string;
      /** Basis points, e.g. 800 = 8% */
      platformDefaultCommissionBps: number;
      standardRate: {
        /** Basis points, e.g. 800 = 8% */
        commissionBps: number;
        source: "seller_default" | "platform_default";
        /** UUID, lowercase canonical form */
        feeScheduleId?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        effectiveFrom?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        effectiveTo?: string;
      };
      categoryOverrides: Array<{
        /** UUID, lowercase canonical form */
        categoryId: string;
        /** UUID, lowercase canonical form */
        feeScheduleId: string;
        /** Basis points, e.g. 800 = 8% */
        commissionBps: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        effectiveFrom: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        effectiveTo?: string;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND' | 'NOT_IMPLEMENTED';
  };
  /** Get one of the calling buyer’s orders: its products, their statuses and what they pay. */
  'orders.order.get': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      orderId: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      orderId: string;
      orderNumber: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      createdAt: string;
      status: "payment_pending" | "payment_failed" | "paid" | "shipped" | "delivered" | "cancelled" | "refunded";
      seller: {
        /** UUID, lowercase canonical form */
        sellerId: string;
        displayName?: string;
      };
      show?: {
        /** UUID, lowercase canonical form */
        showId: string;
        title?: string;
      };
      currency: string;
      shipTo?: {
        name: string;
        line1: string;
        line2?: string;
        city: string;
        region: string;
        postalCode: string;
        country: string;
      };
      products: Array<{
        /** UUID, lowercase canonical form */
        lineId: string;
        /** UUID, lowercase canonical form */
        listingId: string;
        title: string;
        /** UUID, lowercase canonical form */
        variantId?: string;
        variantName?: string;
        coverMediaKey?: string;
        quantity: number;
        /** Money in integer cents (USD) */
        unitPriceCents: number;
        kind: "auction_win" | "bin";
        status: "payment_pending" | "payment_failed" | "paid" | "shipped" | "delivered" | "cancelled" | "refunded";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        soldAt: string;
        afterFailure?: "back_on_sale" | "awaiting_relist";
        fees: Array<{
          type: "item" | "shipping" | "tax" | "commission" | "processing";
          amountCents: number;
          reason: string;
        }>;
      }>;
      money: Array<{
        type: "item" | "shipping" | "tax" | "commission" | "processing";
        amountCents: number;
        reason?: string;
      }>;
      totals: {
        productCount: number;
        /** Money in integer cents (USD) */
        orderTotalCents: number;
      };
      paymentMethod?: {
        brand: string;
        last4: string;
      };
      timeline: Array<{
        step: "sold" | "awaiting_payment" | "paid" | "label_created" | "shipped" | "delivered" | "cancelled";
        state: "done" | "current" | "upcoming";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        at?: string;
      }>;
      shipments: Array<{
        /** UUID, lowercase canonical form */
        shipmentId: string;
        carrier: string;
        service: string;
        trackingNumber?: string;
        status: "label_created" | "in_transit" | "delivered" | "exception" | "returned_to_sender" | "untracked";
        latestEvent?: {
          description: string;
          /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
          at: string;
          location?: string;
        };
      }>;
      actions: {
        updatePaymentMethod: boolean;
        openClaim: boolean;
      };
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'ORDER_NOT_FOUND';
  };
  /** List the calling buyer’s orders, newest first. */
  'orders.order.list': {
    kind: 'query';
    input: {
      limit?: number;
      cursor?: string;
    };
    output: {
      orders: Array<{
        /** UUID, lowercase canonical form */
        orderId: string;
        orderNumber: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        status: "payment_pending" | "payment_failed" | "paid" | "shipped" | "delivered" | "cancelled" | "refunded";
        seller: {
          /** UUID, lowercase canonical form */
          sellerId: string;
          displayName?: string;
        };
        show?: {
          /** UUID, lowercase canonical form */
          showId: string;
          title?: string;
        };
        productTitles: string[];
        productCount: number;
        /** Money in integer cents (USD) */
        totalCents: number;
        currency: string;
        deliveryProblem?: "exception" | "returned_to_sender";
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'INVALID_CURSOR';
  };
  /** List the calling buyer’s saved cards. */
  'orders.paymentmethod.list': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      paymentMethods: Array<{
        /** UUID, lowercase canonical form */
        paymentMethodId: string;
        brand: string;
        last4: string;
        expMonth: number;
        expYear: number;
        isDefault: boolean;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      }>;
      hasCardOnFile: boolean;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** Record a card Stripe has confirmed for a buyer (system). */
  'orders.paymentmethod.record': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
      stripeCustomerId: string;
      stripePaymentMethodId: string;
      brand: string;
      last4: string;
      expMonth: number;
      expYear: number;
    };
    output: {
      /** UUID, lowercase canonical form */
      paymentMethodId: string;
      isDefault: boolean;
      applied: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'CUSTOMER_MISMATCH';
  };
  /** Remove one of the calling buyer’s saved cards. */
  'orders.paymentmethod.remove': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      paymentMethodId: string;
    };
    output: {
      removed: boolean;
      remainingCount: number;
      hasCardOnFile: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'PAYMENT_METHOD_NOT_FOUND' | 'BILLING_UNAVAILABLE';
  };
  /** Open a Stripe SetupIntent so the buyer can save a card. */
  'orders.paymentmethod.setup': {
    kind: 'command';
    input: Record<string, never>;
    output: {
      clientSecret: string;
      setupIntentId: string;
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'BILLING_UNAVAILABLE';
  };
  /** Charge a won lot to the buyer’s saved card. */
  'orders.sale.charge': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      lineId: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      lineId: string;
      state: "pending" | "paid" | "refunded" | "cancelled";
      classification?: "hard_decline" | "soft_decline" | "system_failure" | "ambiguous";
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'LINE_NOT_FOUND';
  };
  /** Record a won auction as an order line, priced and ready to charge. */
  'orders.sale.open': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      auctionId: string;
      /** UUID, lowercase canonical form */
      listingId: string;
      /** UUID, lowercase canonical form */
      sellerId: string;
      /** UUID, lowercase canonical form */
      showId?: string;
      /** UUID, lowercase canonical form */
      buyerUserId: string;
      priceCents: number;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      closedAt: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      orderId: string;
      /** UUID, lowercase canonical form */
      lineId: string;
      state: "pending" | "paid" | "refunded" | "cancelled";
      applied: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'LISTING_NOT_FOUND' | 'SELLER_NOT_FOUND';
  };
  /** Get one of the calling seller’s orders: its products, their statuses and its money. */
  'orders.seller.get': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      orderId: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      orderId: string;
      orderNumber: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      createdAt: string;
      status: "awaiting_payment" | "to_ship" | "shipped" | "delivered" | "cancelled" | "refunded";
      hasIssue: boolean;
      buyerDisplayName?: string;
      show?: {
        /** UUID, lowercase canonical form */
        showId: string;
        title?: string;
      };
      currency: string;
      shipTo?: {
        name: string;
        line1: string;
        line2?: string;
        city: string;
        region: string;
        postalCode: string;
        country: string;
      };
      products: Array<{
        /** UUID, lowercase canonical form */
        lineId: string;
        /** UUID, lowercase canonical form */
        listingId: string;
        title: string;
        /** UUID, lowercase canonical form */
        variantId?: string;
        variantName?: string;
        coverMediaKey?: string;
        quantity: number;
        /** Money in integer cents (USD) */
        unitPriceCents: number;
        kind: "auction_win" | "bin";
        status: "awaiting_payment" | "to_ship" | "shipped" | "delivered" | "cancelled" | "refunded";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        soldAt: string;
        afterFailure?: "back_on_sale" | "awaiting_relist";
        fees: Array<{
          type: "item" | "shipping" | "tax" | "commission" | "processing";
          amountCents: number;
          reason: string;
        }>;
      }>;
      timeline: Array<{
        step: "sold" | "awaiting_payment" | "paid" | "label_created" | "shipped" | "delivered" | "cancelled";
        state: "done" | "current" | "upcoming";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        at?: string;
      }>;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      shipByAt?: string;
      shipments: Array<{
        /** UUID, lowercase canonical form */
        shipmentId: string;
        carrier: string;
        service: string;
        trackingNumber?: string;
        status: "label_created" | "in_transit" | "delivered" | "exception" | "returned_to_sender" | "untracked";
        latestEvent?: {
          description: string;
          /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
          at: string;
          location?: string;
        };
      }>;
      actions: {
        buyLabel: boolean;
        cancel: boolean;
        respondToIssue: boolean;
      };
      money: Array<{
        type: "item" | "shipping" | "tax" | "commission" | "processing";
        amountCents: number;
        reason?: string;
      }>;
      totals: {
        productCount: number;
        /** Money in integer cents (USD) */
        orderTotalCents: number;
        feesCents?: number;
        proceedsCents?: number;
      };
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'ORDER_NOT_FOUND';
  };
  /** List the calling seller’s orders, newest first, with a count per status. */
  'orders.seller.list': {
    kind: 'query';
    input: {
      filter?: "awaiting_payment" | "to_ship" | "shipped" | "delivered" | "cancelled_refunded" | "has_issue";
      statuses?: Array<"awaiting_payment" | "to_ship" | "shipped" | "delivered" | "cancelled" | "refunded">;
      limit?: number;
      cursor?: string;
      withCounts?: boolean;
    };
    output: {
      orders: Array<{
        /** UUID, lowercase canonical form */
        orderId: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        status: "awaiting_payment" | "to_ship" | "shipped" | "delivered" | "cancelled" | "refunded";
        hasIssue: boolean;
        deliveryProblem?: "exception" | "returned_to_sender";
        buyerDisplayName?: string;
        show?: {
          /** UUID, lowercase canonical form */
          showId: string;
          title?: string;
        };
        productTitles: string[];
        productCount: number;
        /** Money in integer cents (USD) */
        totalCents: number;
        currency: string;
      }>;
      counts?: {
        awaiting_payment: number;
        to_ship: number;
        shipped: number;
        delivered: number;
        cancelled_refunded: number;
        has_issue: number;
      };
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'INVALID_CURSOR' | 'FILTER_CONFLICT';
  };
  /** Read the audit log by actor, by capability, by target or for all staff, newest first. */
  'platform.audit.query': {
    kind: 'query';
    input: {
      by: "principal" | "capability" | "staff" | "target";
      /** A principal id (by: "principal"), a capability name (by: "capability") or a seller or user id, a UUID (by: "target"); absent for "staff". */
      key?: string;
      /** Which kind of id the key is: "seller" or "account". With by: "target" only, and required there. */
      kind?: "seller" | "account";
      /** Only records of this capability. With by: "staff", "principal" or "target"; refused with "capability". */
      capability?: string;
      /** Timestamp, epoch milliseconds (UTC) */
      from?: number;
      /** Timestamp, epoch milliseconds (UTC) */
      to?: number;
      limit?: number;
      cursor?: string;
    };
    output: {
      entries: Array<{
        /** Timestamp, epoch milliseconds (UTC) */
        at: number;
        requestId: string;
        capability: string;
        level: "standard" | "high";
        principalId: string;
        principalKind: "guest" | "shopper" | "seller" | "staff" | "partner" | "agent" | "system";
        outcome: "ok" | "error";
        /** The error code, when outcome is error. */
        code?: string;
        /** sha256 of the canonical input; on every record. Not returned yet. */
        inputHash?: string;
        /** The full input; high-audit records only. Not returned yet. */
        input?: unknown;
        /** The output after auditRedact; high-audit records only. Not returned yet. */
        output?: unknown;
        reason?: string;
        ticketRef?: string;
        replayed?: boolean;
        /** The staff group whose scope the call used, e.g. "ops"; staff only. */
        roleUsed?: string;
        /** What changed, labelled from enum values (e.g. "Active → Suspended · 7 days"), never raw input. */
        transition?: string;
        /** The sellers and accounts the record is filed under, as its capability’s auditTarget declares. */
        targets?: Array<{
          kind: "seller" | "account";
          /** UUID, lowercase canonical form */
          id: string;
        }>;
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'INVALID_QUERY' | 'INVALID_CURSOR' | 'NOT_IMPLEMENTED';
  };
  /** Return the feature flags a client may see, evaluated for the caller. */
  'platform.flags.get': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      /** Flag key to evaluated value; most are booleans. Absent means off. */
      flags: Record<string, unknown>;
    };
    idempotency: 'none';
    access: 'public';
    errors: never;
  };
  /** Report API liveness and authoritative server time. */
  'platform.health.ping': {
    kind: 'query';
    input: {
      /** Echoed back verbatim for connectivity checks */
      echo?: string;
    };
    output: {
      ok: boolean;
      /** Timestamp, epoch milliseconds (UTC) */
      serverNow: number;
      echo?: string;
    };
    idempotency: 'none';
    access: 'public';
    errors: never;
  };
  /** List the commission schedules that apply to the calling seller. */
  'sellers.feeschedule.get': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      platformDefaultCommissionBps: number;
      schedules: Array<{
        /** UUID, lowercase canonical form */
        feeScheduleId: string;
        /** UUID, lowercase canonical form */
        categoryId?: string;
        commissionBps: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        effectiveFrom: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        effectiveTo?: string;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_A_SELLER';
  };
  /** List the commission schedules on one seller account (staff). */
  'sellers.feeschedule.list': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      platformDefaultCommissionBps: number;
      schedules: Array<{
        /** UUID, lowercase canonical form */
        feeScheduleId: string;
        /** UUID, lowercase canonical form */
        categoryId?: string;
        commissionBps: number;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        effectiveFrom: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        effectiveTo?: string;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND';
  };
  /** Set a seller’s commission rate for an effective window (staff, Payments). */
  'sellers.feeschedule.set': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      /** UUID, lowercase canonical form */
      categoryId?: string;
      /** Basis points, 0 to 3000 (0–30%), e.g. 800 = 8% */
      commissionBps: number;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      effectiveFrom: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      effectiveTo?: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      feeScheduleId: string;
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND' | 'INVALID_WINDOW' | 'OVERLAPPING_WINDOW';
  };
  /** Replace the commission rate a seller pays from now on (staff, Payments). */
  'sellers.feeschedule.supersede': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      /** UUID, lowercase canonical form */
      categoryId?: string;
      /** Basis points, 0 to 3000 (0–30%), e.g. 800 = 8% */
      commissionBps: number;
      /** UUID, lowercase canonical form */
      replaces?: string;
      /** Why the rate is changing */
      reason: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      feeScheduleId: string;
      /** UUID, lowercase canonical form */
      closedFeeScheduleId?: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      effectiveFrom: string;
      cancelledFeeScheduleIds: string[];
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND' | 'SCHEDULE_CHANGED' | 'UNCHANGED_RATE' | 'NOT_IMPLEMENTED';
  };
  /** Accept an invitation to join a seller team. */
  'sellers.invitation.accept': {
    kind: 'command';
    input: {
      code: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      role: "admin" | "seller" | "support";
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'INVITATION_NOT_FOUND' | 'EMAIL_NOT_VERIFIED' | 'EMAIL_MISMATCH' | 'ALREADY_ON_A_TEAM' | 'NOT_IMPLEMENTED';
  };
  /** Look up an invitation to join a seller team by the code in its link. */
  'sellers.invitation.get': {
    kind: 'query';
    input: {
      code: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      storeName: string;
      role: "admin" | "seller" | "support";
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      expiresAt: string;
      emailMatches: boolean;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'INVITATION_NOT_FOUND' | 'NOT_IMPLEMENTED';
  };
  /** List the calling seller’s pending team invitations, a page at a time. */
  'sellers.invitation.list': {
    kind: 'query';
    input: {
      limit?: number;
      cursor?: string;
    };
    output: {
      invitations: Array<{
        /** UUID, lowercase canonical form */
        invitationId: string;
        email: string;
        role: "admin" | "seller" | "support";
        /** UUID, lowercase canonical form */
        invitedByUserId: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        invitedAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        expiresAt: string;
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'INVALID_CURSOR' | 'NOT_IMPLEMENTED';
  };
  /** Revoke a pending invitation to the calling seller’s team. */
  'sellers.invitation.revoke': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      invitationId: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      invitationId: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'INVITATION_NOT_FOUND' | 'NOT_IMPLEMENTED';
  };
  /** Apply a Stripe Express KYC verdict to a seller (system). */
  'sellers.kyc.record': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      stripeAccountId: string;
      verdict: "verified" | "rejected" | "pending";
      reason?: string;
    };
    output: {
      state: "pending_kyc" | "active" | "restricted" | "suspended";
      applied: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND' | 'ACCOUNT_MISMATCH' | 'CONCURRENT_UPDATE';
  };
  /** Ask Stripe for the seller’s KYC verdict now, and apply it. */
  'sellers.kyc.refresh': {
    kind: 'command';
    input: Record<string, never>;
    output: {
      state: "pending_kyc" | "active" | "restricted" | "suspended";
      applied: boolean;
      verdict?: "verified" | "rejected" | "pending";
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_A_SELLER' | 'CONNECT_UNAVAILABLE' | 'CONCURRENT_UPDATE';
  };
  /** Create or refresh the seller’s Stripe Express onboarding link. */
  'sellers.kyc.start': {
    kind: 'command';
    input: {
      returnTo?: "web" | "app";
    };
    output: {
      onboardingUrl: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      expiresAt: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_A_SELLER' | 'PHONE_NOT_VERIFIED' | 'ALREADY_ACTIVE' | 'CONNECT_UNAVAILABLE' | 'CONCURRENT_UPDATE';
  };
  /** Invite a person, by email, to join the calling seller’s team in a role. */
  'sellers.member.invite': {
    kind: 'command';
    input: {
      email: string;
      role: "admin" | "seller" | "support";
    };
    output: {
      invitation: {
        /** UUID, lowercase canonical form */
        invitationId: string;
        email: string;
        role: "admin" | "seller" | "support";
        /** UUID, lowercase canonical form */
        invitedByUserId: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        invitedAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        expiresAt: string;
      };
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'ALREADY_A_MEMBER' | 'INVITATION_PENDING' | 'NOT_IMPLEMENTED';
  };
  /** Leave the seller team the caller is acting for. */
  'sellers.member.leave': {
    kind: 'command';
    input: Record<string, never>;
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'OWNER_CANNOT_LEAVE' | 'NOT_IMPLEMENTED';
  };
  /** List the members of the calling seller’s team, a page at a time. */
  'sellers.member.list': {
    kind: 'query';
    input: {
      limit?: number;
      cursor?: string;
    };
    output: {
      members: Array<{
        /** UUID, lowercase canonical form */
        userId: string;
        displayName: string;
        role: "owner" | "admin" | "seller" | "support";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        joinedAt: string;
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'INVALID_CURSOR' | 'NOT_IMPLEMENTED';
  };
  /** Remove a member from the calling seller’s team, effective immediately. */
  'sellers.member.remove': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      userId: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'NOT_A_MEMBER' | 'CANNOT_REMOVE_OWNER' | 'NOT_IMPLEMENTED';
  };
  /** Give a member of the calling seller’s team a different role. */
  'sellers.member.update': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      userId: string;
      role: "admin" | "seller" | "support";
    };
    output: {
      member: {
        /** UUID, lowercase canonical form */
        userId: string;
        displayName: string;
        role: "owner" | "admin" | "seller" | "support";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        joinedAt: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'NOT_A_MEMBER' | 'OWNER_ROLE_FIXED' | 'NOT_IMPLEMENTED';
  };
  /** Return the seller onboarding checklist and the next step to take. */
  'sellers.onboarding.checklist': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      state: "pending_kyc" | "active" | "restricted" | "suspended";
      steps: Array<{
        step: "phone_verification" | "stripe_kyc" | "storefront_profile";
        done: boolean;
        next: boolean;
      }>;
      canGoLive: boolean;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_A_SELLER';
  };
  /** Send an SMS verification code to a seller’s phone number. */
  'sellers.phone.request': {
    kind: 'command';
    input: {
      /** E.164 format, e.g. +12025550123 */
      phoneE164: string;
    };
    output: {
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      expiresAt: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      resendAvailableAt: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_A_SELLER' | 'NOT_THE_OWNER' | 'ALREADY_VERIFIED' | 'TOO_MANY_REQUESTS' | 'SMS_SEND_FAILED';
  };
  /** Verify an SMS code and clear the seller phone gate. */
  'sellers.phone.verify': {
    kind: 'command';
    input: {
      /** The six-digit code from the SMS */
      code: string;
    };
    output: {
      verifiedAt: string;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_A_SELLER' | 'NOT_THE_OWNER' | 'NO_CODE_OUTSTANDING' | 'CODE_EXPIRED' | 'CODE_INCORRECT' | 'TOO_MANY_ATTEMPTS' | 'CONCURRENT_UPDATE';
  };
  /** Fetch a seller’s public storefront profile by handle or id. */
  'sellers.profile.get': {
    kind: 'query';
    input: {
      handle?: string;
      sellerId?: string;
    };
    output: {
      seller: {
        /** UUID, lowercase canonical form */
        sellerId: string;
        handle?: string;
        displayName: string;
        bio?: string;
        avatarUrl?: string;
        canGoLive: boolean;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        memberSince: string;
      };
    };
    idempotency: 'none';
    access: 'public';
    errors: 'SELLER_NOT_FOUND' | 'AMBIGUOUS_LOOKUP';
  };
  /** Update the calling seller’s storefront handle, name, bio or avatar. */
  'sellers.profile.update': {
    kind: 'command';
    input: {
      /** Public storefront handle, claimable once */
      handle?: string;
      displayName?: string;
      bio?: string;
      avatarUrl?: string;
    };
    output: {
      seller: {
        /** UUID, lowercase canonical form */
        sellerId: string;
        handle?: string;
        displayName: string;
        bio?: string;
        avatarUrl?: string;
        canGoLive: boolean;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        memberSince: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_A_SELLER' | 'NOTHING_TO_UPDATE' | 'HANDLE_TAKEN' | 'HANDLE_RESERVED' | 'HANDLE_IMMUTABLE' | 'CONCURRENT_UPDATE';
  };
  /** List every seller, newest first, a page at a time, optionally in one state (staff). */
  'sellers.seller.list': {
    kind: 'query';
    input: {
      state?: "pending_kyc" | "active" | "restricted" | "suspended";
      limit?: number;
      cursor?: string;
    };
    output: {
      sellers: Array<{
        /** UUID, lowercase canonical form */
        sellerId: string;
        /** UUID, lowercase canonical form */
        userId: string;
        handle?: string;
        displayName: string;
        avatarUrl?: string;
        state: "pending_kyc" | "active" | "restricted" | "suspended";
        trustTier: "new" | "established" | "trusted";
        stripeAccountId?: string;
        smsVerified: boolean;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'INVALID_CURSOR';
  };
  /** End a seller’s suspension early (staff). */
  'sellers.seller.reinstate': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      /** Why the suspension is ending early. Kept with the audit record; on no event. */
      reason: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      state: "active" | "restricted";
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND' | 'NOT_SUSPENDED' | 'CONCURRENT_UPDATE' | 'NOT_IMPLEMENTED';
  };
  /** Find sellers by handle, store name, Stripe account, seller id or user id (staff). */
  'sellers.seller.search': {
    kind: 'query';
    input: {
      by: "handle" | "name" | "stripeAccountId" | "sellerId" | "userId";
      q: string;
      limit?: number;
    };
    output: {
      sellers: Array<{
        /** UUID, lowercase canonical form */
        sellerId: string;
        /** UUID, lowercase canonical form */
        userId: string;
        handle?: string;
        displayName: string;
        avatarUrl?: string;
        state: "pending_kyc" | "active" | "restricted" | "suspended";
        trustTier: "new" | "established" | "trusted";
        stripeAccountId?: string;
        smsVerified: boolean;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
      }>;
      truncated: boolean;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'INVALID_QUERY';
  };
  /** Suspend a seller for 3, 7 or 30 days (staff). */
  'sellers.seller.suspend': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      /** Days, counted from the moment it is applied. 3, 7 or 30; the console defaults to 7. */
      duration: 3 | 7 | 30;
      reason: "prohibited_items" | "counterfeit_reports" | "fraud" | "chargeback_rate" | "repeated_late_shipping" | "policy_violation" | "other";
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      state: "suspended";
      suspendedFrom: "active" | "restricted";
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      suspendedUntil: string;
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND' | 'NOT_SUSPENDABLE' | 'ALREADY_SUSPENDED' | 'CONCURRENT_UPDATE' | 'NOT_IMPLEMENTED';
  };
  /** Add an internal staff note to a seller account (staff). */
  'sellers.staffnote.add': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      /** The note. Staff-only. */
      body: string;
      /** A ticket id (such as GO-380 or ZD-4411) or an http(s) link: printable ASCII, at most 512 characters. */
      ticketRef?: string;
    };
    output: {
      note: {
        /** UUID, lowercase canonical form */
        noteId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        body?: string;
        /** A ticket id (such as GO-380 or ZD-4411) or an http(s) link: printable ASCII, at most 512 characters. */
        ticketRef?: string;
        authorPrincipalId: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        redactedAt?: string;
        redactedByPrincipalId?: string;
        redactionReason?: string;
      };
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND';
  };
  /** List the internal staff notes on a seller account, newest first (staff). */
  'sellers.staffnote.list': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      limit?: number;
      cursor?: string;
    };
    output: {
      notes: Array<{
        /** UUID, lowercase canonical form */
        noteId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        body?: string;
        /** A ticket id (such as GO-380 or ZD-4411) or an http(s) link: printable ASCII, at most 512 characters. */
        ticketRef?: string;
        authorPrincipalId: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        redactedAt?: string;
        redactedByPrincipalId?: string;
        redactionReason?: string;
      }>;
      nextCursor?: string;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND' | 'INVALID_CURSOR';
  };
  /** Redact an internal staff note, keeping the record that it existed (staff). */
  'sellers.staffnote.redact': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      noteId: string;
      /** Stored on the note as the redaction reason */
      reason: string;
    };
    output: {
      note: {
        /** UUID, lowercase canonical form */
        noteId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        body?: string;
        /** A ticket id (such as GO-380 or ZD-4411) or an http(s) link: printable ASCII, at most 512 characters. */
        ticketRef?: string;
        authorPrincipalId: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        redactedAt?: string;
        redactedByPrincipalId?: string;
        redactionReason?: string;
      };
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'NOTE_NOT_FOUND' | 'ALREADY_REDACTED';
  };
  /** Return the calling seller’s state, trust tier and onboarding gates. */
  'sellers.standing.get': {
    kind: 'query';
    input: Record<string, never>;
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      state: "pending_kyc" | "active" | "restricted" | "suspended";
      trustTier: "new" | "established" | "trusted";
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      tierComputedAt?: string;
      tierInputs?: Record<string, number | string | boolean>;
      nextTier?: "new" | "established" | "trusted";
      nextTierRequirements: string[];
      gates: {
        smsVerified: boolean;
        kycComplete: boolean;
        canGoLive: boolean;
        payoutsEnabled: boolean;
      };
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND' | 'NOT_A_SELLER';
  };
  /** Read one seller’s trust-tier history, oldest first (staff). */
  'sellers.tier.history': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      currentTier: "new" | "established" | "trusted";
      entries: Array<{
        fromTier: "new" | "established" | "trusted";
        toTier: "new" | "established" | "trusted";
        inputs: Record<string, number | string | boolean>;
        cause: "recomputed" | "staff_override";
        reason?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        computedAt: string;
        actorPrincipalId?: string;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND';
  };
  /** Set a seller’s trust tier by hand (staff). */
  'sellers.tier.override': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      tier: "new" | "established" | "trusted";
      /** Why the computed tier is being overridden */
      reason: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      tier: "new" | "established" | "trusted";
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'SELLER_NOT_FOUND' | 'ALREADY_IN_TIER' | 'CONCURRENT_UPDATE';
  };
  /** Admit a waitlisted user and create their seller record (staff). */
  'sellers.waitlist.admit': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      waitlistEntryId: string;
      displayName: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      sellerId: string;
      /** UUID, lowercase canonical form */
      userId: string;
      state: "pending_kyc";
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'WAITLIST_ENTRY_NOT_FOUND' | 'ALREADY_DECIDED' | 'ALREADY_A_SELLER';
  };
  /** Join the seller waitlist, or update a standing request. */
  'sellers.waitlist.join': {
    kind: 'command';
    input: {
      /** Categories the seller intends to list in */
      categoryIds: string[];
      expectedMonthlyGmvCents?: number;
      note?: string;
    };
    output: {
      /** UUID, lowercase canonical form */
      waitlistEntryId: string;
      state: "pending" | "admitted" | "declined";
      created: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'ACCOUNT_NOT_FOUND';
  };
  /** List waitlist entries for the admit queue (staff). */
  'sellers.waitlist.list': {
    kind: 'query';
    input: {
      state?: "pending" | "admitted" | "declined";
      limit?: number;
    };
    output: {
      entries: Array<{
        /** UUID, lowercase canonical form */
        waitlistEntryId: string;
        /** UUID, lowercase canonical form */
        userId: string;
        categoryIds: string[];
        expectedMonthlyGmvCents?: number;
        note?: string;
        state: "pending" | "admitted" | "declined";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        createdAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        decidedAt?: string;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: never;
  };
  /** Recent messages from a show’s chat. */
  'shows.chat.history': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
      limit?: number;
    };
    output: {
      messages: Array<{
        /** UUID, lowercase canonical form */
        messageId: string;
        at: number;
        displayName: string;
        body?: string;
        removed: boolean;
      }>;
    };
    idempotency: 'none';
    access: 'public';
    errors: never;
  };
  /** Post a message to a live show’s chat. */
  'shows.chat.post': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
      body: string;
    };
    output: {
      message: {
        /** UUID, lowercase canonical form */
        messageId: string;
        at: number;
        displayName: string;
        body?: string;
        removed: boolean;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'SHOW_NOT_FOUND' | 'SHOW_NOT_LIVE' | 'MESSAGE_EMPTY';
  };
  /** Remove a message from your show’s chat. */
  'shows.chat.remove': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
      /** UUID, lowercase canonical form */
      messageId: string;
      /** Timestamp, epoch milliseconds (UTC) */
      at: number;
    };
    output: {
      removed: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SHOW_NOT_FOUND' | 'MESSAGE_NOT_FOUND';
  };
  /** Add one of your listings to a show’s lineup. */
  'shows.lineup.add': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
      /** UUID, lowercase canonical form */
      listingId: string;
    };
    output: {
      entry: {
        /** UUID, lowercase canonical form */
        entryId: string;
        /** UUID, lowercase canonical form */
        listingId: string;
        position: number;
        state: "pending" | "skipped";
        title: string;
        coverMediaKey?: string;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
      };
      auctionable: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SHOW_NOT_FOUND' | 'SHOW_OVER' | 'LISTING_NOT_FOUND' | 'ALREADY_ON_LINEUP';
  };
  /** Remove a lot from a show’s lineup. */
  'shows.lineup.remove': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
      /** UUID, lowercase canonical form */
      entryId: string;
    };
    output: {
      removed: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SHOW_NOT_FOUND' | 'ENTRY_NOT_FOUND';
  };
  /** Report that you are watching, and get the live count. */
  'shows.presence.heartbeat': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
    };
    output: {
      watching: number;
    };
    idempotency: 'natural';
    access: 'public';
    errors: 'SHOW_NOT_LIVE';
  };
  /** Send reactions to a live show. */
  'shows.reaction.send': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
      count: number;
      nonce?: string;
    };
    output: {
      sent: number;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'SHOW_NOT_FOUND' | 'SHOW_NOT_LIVE';
  };
  /** Browse live and upcoming shows. */
  'shows.show.browse': {
    kind: 'query';
    input: {
      limit?: number;
    };
    output: {
      shows: Array<{
        /** UUID, lowercase canonical form */
        showId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        sellerDisplayName: string;
        title: string;
        state: "scheduled" | "live" | "ended" | "cancelled";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        scheduledStartAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        startedAt?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endedAt?: string;
        lineupSize: number;
        coverMediaKey?: string;
        serverNowMs: number;
      }>;
    };
    idempotency: 'none';
    access: 'public';
    errors: never;
  };
  /** Stop broadcasting a show. */
  'shows.show.end': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
    };
    output: {
      show: {
        /** UUID, lowercase canonical form */
        showId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        sellerDisplayName: string;
        title: string;
        state: "scheduled" | "live" | "ended" | "cancelled";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        scheduledStartAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        startedAt?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endedAt?: string;
        lineupSize: number;
        coverMediaKey?: string;
        serverNowMs: number;
      };
      stageTornDown: boolean;
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SHOW_NOT_FOUND' | 'SHOW_NOT_LIVE' | 'SHOW_BUSY';
  };
  /** Fetch a show and its lineup. */
  'shows.show.get': {
    kind: 'query';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
    };
    output: {
      show: {
        /** UUID, lowercase canonical form */
        showId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        sellerDisplayName: string;
        title: string;
        state: "scheduled" | "live" | "ended" | "cancelled";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        scheduledStartAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        startedAt?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endedAt?: string;
        lineupSize: number;
        coverMediaKey?: string;
        serverNowMs: number;
      };
      lineup: Array<{
        /** UUID, lowercase canonical form */
        entryId: string;
        /** UUID, lowercase canonical form */
        listingId: string;
        position: number;
        state: "pending" | "skipped";
        title: string;
        coverMediaKey?: string;
        /** Money in integer cents (USD) */
        startPriceCents?: number;
      }>;
    };
    idempotency: 'none';
    access: 'public';
    errors: 'SHOW_NOT_FOUND';
  };
  /** Start broadcasting a show, and get the credentials to publish. */
  'shows.show.golive': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
    };
    output: {
      show: {
        /** UUID, lowercase canonical form */
        showId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        sellerDisplayName: string;
        title: string;
        state: "scheduled" | "live" | "ended" | "cancelled";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        scheduledStartAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        startedAt?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endedAt?: string;
        lineupSize: number;
        coverMediaKey?: string;
        serverNowMs: number;
      };
      broadcast: {
        token: string;
        participantId: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        expiresAt: string;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'SHOW_NOT_FOUND' | 'SHOW_OVER' | 'SHOW_BUSY' | 'VIDEO_UNAVAILABLE';
  };
  /** Staff: end a live show now, with a stated reason. */
  'shows.show.kill': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
      /** Travels on SHOW_ENDED and into the T&S timeline */
      reason: string;
    };
    output: {
      show: {
        /** UUID, lowercase canonical form */
        showId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        sellerDisplayName: string;
        title: string;
        state: "scheduled" | "live" | "ended" | "cancelled";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        scheduledStartAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        startedAt?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endedAt?: string;
        lineupSize: number;
        coverMediaKey?: string;
        serverNowMs: number;
      };
      stageTornDown: boolean;
    };
    idempotency: 'keyed';
    access: 'authenticated';
    errors: 'SHOW_NOT_FOUND' | 'SHOW_NOT_LIVE' | 'SHOW_BUSY' | 'NOT_IMPLEMENTED';
  };
  /** List your own shows. */
  'shows.show.list': {
    kind: 'query';
    input: {
      limit?: number;
    };
    output: {
      shows: Array<{
        /** UUID, lowercase canonical form */
        showId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        sellerDisplayName: string;
        title: string;
        state: "scheduled" | "live" | "ended" | "cancelled";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        scheduledStartAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        startedAt?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endedAt?: string;
        lineupSize: number;
        coverMediaKey?: string;
        serverNowMs: number;
      }>;
    };
    idempotency: 'none';
    access: 'authenticated';
    errors: 'NOT_A_SELLER';
  };
  /** Schedule a live show. */
  'shows.show.schedule': {
    kind: 'command';
    input: {
      title: string;
      /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
      scheduledStartAt: string;
    };
    output: {
      show: {
        /** UUID, lowercase canonical form */
        showId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        sellerDisplayName: string;
        title: string;
        state: "scheduled" | "live" | "ended" | "cancelled";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        scheduledStartAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        startedAt?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endedAt?: string;
        lineupSize: number;
        coverMediaKey?: string;
        serverNowMs: number;
      };
    };
    idempotency: 'natural';
    access: 'authenticated';
    errors: 'NOT_A_SELLER' | 'START_TIME_UNREASONABLE';
  };
  /** Get subscribe-only credentials to watch a live show. */
  'shows.viewer.join': {
    kind: 'command';
    input: {
      /** UUID, lowercase canonical form */
      showId: string;
    };
    output: {
      show: {
        /** UUID, lowercase canonical form */
        showId: string;
        /** UUID, lowercase canonical form */
        sellerId: string;
        sellerDisplayName: string;
        title: string;
        state: "scheduled" | "live" | "ended" | "cancelled";
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        scheduledStartAt: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        startedAt?: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        endedAt?: string;
        lineupSize: number;
        coverMediaKey?: string;
        serverNowMs: number;
      };
      viewer: {
        token: string;
        participantId: string;
        /** Timestamp, ISO-8601 UTC (e.g. 2026-08-22T14:03:22.123Z) */
        expiresAt: string;
      };
    };
    idempotency: 'natural';
    access: 'public';
    errors: 'SHOW_NOT_FOUND' | 'SHOW_NOT_LIVE' | 'VIDEO_UNAVAILABLE';
  };
}

/**
 * Runtime facts only — no schemas. Validation is the server's job (it owns the
 * compiled TypeBox checkers); a second copy in the client would be a second
 * answer, and the one that disagrees is always the client.
 */
export const CAPABILITY_MANIFEST = {
  'auctions.auction.browse': { kind: 'query', idempotency: 'none', cache: { maxAgeSeconds: 10, scope: 'public' } },
  'auctions.auction.cancel': { kind: 'command', idempotency: 'natural' },
  'auctions.auction.current': { kind: 'query', idempotency: 'none' },
  'auctions.auction.get': { kind: 'query', idempotency: 'none' },
  'auctions.auction.launch': { kind: 'command', idempotency: 'natural' },
  'auctions.auction.schedule': { kind: 'command', idempotency: 'natural' },
  'auctions.auction.settle': { kind: 'command', idempotency: 'natural' },
  'auctions.bid.history': { kind: 'query', idempotency: 'none' },
  'auctions.bid.place': { kind: 'command', idempotency: 'natural' },
  'auctions.bid.position': { kind: 'query', idempotency: 'none' },
  'auctions.buynow.purchase': { kind: 'command', idempotency: 'keyed' },
  'auctions.eligibility.set': { kind: 'command', idempotency: 'natural' },
  'auctions.settlement.report': { kind: 'command', idempotency: 'natural' },
  'catalog.category.get': { kind: 'query', idempotency: 'none', cache: { maxAgeSeconds: 300, scope: 'public' } },
  'catalog.import.advance': { kind: 'command', idempotency: 'natural' },
  'catalog.import.begin': { kind: 'command', idempotency: 'natural' },
  'catalog.import.confirm': { kind: 'command', idempotency: 'natural' },
  'catalog.import.images': { kind: 'command', idempotency: 'natural' },
  'catalog.import.imagework': { kind: 'query', idempotency: 'none' },
  'catalog.import.list': { kind: 'query', idempotency: 'none' },
  'catalog.import.load': { kind: 'command', idempotency: 'natural' },
  'catalog.import.propose': { kind: 'command', idempotency: 'natural' },
  'catalog.import.publish': { kind: 'command', idempotency: 'natural' },
  'catalog.import.publishrows': { kind: 'command', idempotency: 'natural' },
  'catalog.import.rows': { kind: 'command', idempotency: 'natural' },
  'catalog.import.start': { kind: 'command', idempotency: 'keyed' },
  'catalog.import.status': { kind: 'query', idempotency: 'none' },
  'catalog.intake.add': { kind: 'command', idempotency: 'natural' },
  'catalog.intake.answer': { kind: 'command', idempotency: 'natural' },
  'catalog.intake.confirm': { kind: 'command', idempotency: 'keyed' },
  'catalog.intake.defaults': { kind: 'command', idempotency: 'natural' },
  'catalog.intake.fill': { kind: 'command', idempotency: 'natural' },
  'catalog.intake.finish': { kind: 'command', idempotency: 'natural' },
  'catalog.intake.retry': { kind: 'command', idempotency: 'keyed' },
  'catalog.intake.start': { kind: 'command', idempotency: 'keyed' },
  'catalog.intake.status': { kind: 'query', idempotency: 'none' },
  'catalog.inventory.adjust': { kind: 'command', idempotency: 'natural' },
  'catalog.listing.archive': { kind: 'command', idempotency: 'natural' },
  'catalog.listing.browse': { kind: 'query', idempotency: 'none', cache: { maxAgeSeconds: 60, scope: 'public' } },
  'catalog.listing.create': { kind: 'command', idempotency: 'natural' },
  'catalog.listing.export': { kind: 'query', idempotency: 'none' },
  'catalog.listing.get': { kind: 'query', idempotency: 'none' },
  'catalog.listing.identify': { kind: 'command', idempotency: 'natural' },
  'catalog.listing.list': { kind: 'query', idempotency: 'none' },
  'catalog.listing.prefill': { kind: 'command', idempotency: 'natural' },
  'catalog.listing.publish': { kind: 'command', idempotency: 'natural' },
  'catalog.listing.quickcreate': { kind: 'command', idempotency: 'natural' },
  'catalog.listing.revise': { kind: 'command', idempotency: 'natural' },
  'catalog.listing.takedown': { kind: 'command', idempotency: 'keyed' },
  'catalog.listing.update': { kind: 'command', idempotency: 'natural' },
  'catalog.media.attach': { kind: 'command', idempotency: 'natural' },
  'catalog.media.presign': { kind: 'command', idempotency: 'natural' },
  'catalog.media.remove': { kind: 'command', idempotency: 'natural' },
  'catalog.media.reorder': { kind: 'command', idempotency: 'natural' },
  'catalog.taxonomy.changes': { kind: 'query', idempotency: 'none' },
  'catalog.taxonomy.children': { kind: 'query', idempotency: 'none' },
  'catalog.taxonomy.decide': { kind: 'command', idempotency: 'keyed' },
  'catalog.taxonomy.get': { kind: 'query', idempotency: 'none', cache: { maxAgeSeconds: 300, scope: 'public' } },
  'catalog.taxonomy.inspect': { kind: 'query', idempotency: 'none' },
  'catalog.taxonomy.search': { kind: 'query', idempotency: 'none' },
  'catalog.taxonomy.setrule': { kind: 'command', idempotency: 'natural' },
  'catalog.taxonomy.setstatus': { kind: 'command', idempotency: 'natural' },
  'catalog.variant.set': { kind: 'command', idempotency: 'natural' },
  'discovery.listing.browse': { kind: 'query', idempotency: 'none', cache: { maxAgeSeconds: 60, scope: 'public' } },
  'discovery.listing.record': { kind: 'command', idempotency: 'natural' },
  'discovery.notification.confirmReceipt': { kind: 'command', idempotency: 'natural' },
  'discovery.notification.count': { kind: 'query', idempotency: 'none' },
  'discovery.notification.imageUpload': { kind: 'command', idempotency: 'natural' },
  'discovery.notification.list': { kind: 'query', idempotency: 'none' },
  'discovery.notification.markRead': { kind: 'command', idempotency: 'natural' },
  'discovery.notification.markReceived': { kind: 'command', idempotency: 'natural' },
  'discovery.notification.send': { kind: 'command', idempotency: 'keyed' },
  'discovery.notifprefs.get': { kind: 'query', idempotency: 'none' },
  'discovery.notifprefs.set': { kind: 'command', idempotency: 'natural' },
  'identity.account.create': { kind: 'command', idempotency: 'natural' },
  'identity.account.names': { kind: 'query', idempotency: 'none' },
  'identity.account.restore': { kind: 'command', idempotency: 'keyed' },
  'identity.account.search': { kind: 'query', idempotency: 'none' },
  'identity.account.signout': { kind: 'command', idempotency: 'keyed' },
  'identity.account.suspend': { kind: 'command', idempotency: 'keyed' },
  'identity.authmethod.link': { kind: 'command', idempotency: 'natural' },
  'identity.authmethod.list': { kind: 'query', idempotency: 'none' },
  'identity.authmethod.unlink': { kind: 'command', idempotency: 'natural' },
  'identity.consent.grant': { kind: 'command', idempotency: 'natural' },
  'identity.consent.list': { kind: 'query', idempotency: 'none' },
  'identity.consent.revoke': { kind: 'command', idempotency: 'natural' },
  'identity.email.reveal': { kind: 'query', idempotency: 'none' },
  'identity.interests.set': { kind: 'command', idempotency: 'natural' },
  'identity.profile.get': { kind: 'query', idempotency: 'none' },
  'identity.profile.update': { kind: 'command', idempotency: 'natural' },
  'identity.pushtoken.list': { kind: 'query', idempotency: 'none' },
  'identity.pushtoken.register': { kind: 'command', idempotency: 'natural' },
  'orders.commission.preview': { kind: 'query', idempotency: 'none' },
  'orders.order.get': { kind: 'query', idempotency: 'none' },
  'orders.order.list': { kind: 'query', idempotency: 'none' },
  'orders.paymentmethod.list': { kind: 'query', idempotency: 'none' },
  'orders.paymentmethod.record': { kind: 'command', idempotency: 'natural' },
  'orders.paymentmethod.remove': { kind: 'command', idempotency: 'natural' },
  'orders.paymentmethod.setup': { kind: 'command', idempotency: 'keyed' },
  'orders.sale.charge': { kind: 'command', idempotency: 'natural' },
  'orders.sale.open': { kind: 'command', idempotency: 'natural' },
  'orders.seller.get': { kind: 'query', idempotency: 'none' },
  'orders.seller.list': { kind: 'query', idempotency: 'none' },
  'platform.audit.query': { kind: 'query', idempotency: 'none' },
  'platform.flags.get': { kind: 'query', idempotency: 'none' },
  'platform.health.ping': { kind: 'query', idempotency: 'none' },
  'sellers.feeschedule.get': { kind: 'query', idempotency: 'none' },
  'sellers.feeschedule.list': { kind: 'query', idempotency: 'none' },
  'sellers.feeschedule.set': { kind: 'command', idempotency: 'keyed' },
  'sellers.feeschedule.supersede': { kind: 'command', idempotency: 'keyed' },
  'sellers.invitation.accept': { kind: 'command', idempotency: 'natural' },
  'sellers.invitation.get': { kind: 'query', idempotency: 'none' },
  'sellers.invitation.list': { kind: 'query', idempotency: 'none' },
  'sellers.invitation.revoke': { kind: 'command', idempotency: 'natural' },
  'sellers.kyc.record': { kind: 'command', idempotency: 'natural' },
  'sellers.kyc.refresh': { kind: 'command', idempotency: 'natural' },
  'sellers.kyc.start': { kind: 'command', idempotency: 'natural' },
  'sellers.member.invite': { kind: 'command', idempotency: 'keyed' },
  'sellers.member.leave': { kind: 'command', idempotency: 'natural' },
  'sellers.member.list': { kind: 'query', idempotency: 'none' },
  'sellers.member.remove': { kind: 'command', idempotency: 'natural' },
  'sellers.member.update': { kind: 'command', idempotency: 'natural' },
  'sellers.onboarding.checklist': { kind: 'query', idempotency: 'none', cache: { maxAgeSeconds: 0, scope: 'private' } },
  'sellers.phone.request': { kind: 'command', idempotency: 'natural' },
  'sellers.phone.verify': { kind: 'command', idempotency: 'natural' },
  'sellers.profile.get': { kind: 'query', idempotency: 'none', cache: { maxAgeSeconds: 60, scope: 'public' } },
  'sellers.profile.update': { kind: 'command', idempotency: 'natural' },
  'sellers.seller.list': { kind: 'query', idempotency: 'none' },
  'sellers.seller.reinstate': { kind: 'command', idempotency: 'keyed' },
  'sellers.seller.search': { kind: 'query', idempotency: 'none' },
  'sellers.seller.suspend': { kind: 'command', idempotency: 'keyed' },
  'sellers.staffnote.add': { kind: 'command', idempotency: 'keyed' },
  'sellers.staffnote.list': { kind: 'query', idempotency: 'none' },
  'sellers.staffnote.redact': { kind: 'command', idempotency: 'keyed' },
  'sellers.standing.get': { kind: 'query', idempotency: 'none' },
  'sellers.tier.history': { kind: 'query', idempotency: 'none' },
  'sellers.tier.override': { kind: 'command', idempotency: 'keyed' },
  'sellers.waitlist.admit': { kind: 'command', idempotency: 'keyed' },
  'sellers.waitlist.join': { kind: 'command', idempotency: 'natural' },
  'sellers.waitlist.list': { kind: 'query', idempotency: 'none' },
  'shows.chat.history': { kind: 'query', idempotency: 'none' },
  'shows.chat.post': { kind: 'command', idempotency: 'natural' },
  'shows.chat.remove': { kind: 'command', idempotency: 'natural' },
  'shows.lineup.add': { kind: 'command', idempotency: 'natural' },
  'shows.lineup.remove': { kind: 'command', idempotency: 'natural' },
  'shows.presence.heartbeat': { kind: 'command', idempotency: 'natural' },
  'shows.reaction.send': { kind: 'command', idempotency: 'natural' },
  'shows.show.browse': { kind: 'query', idempotency: 'none', cache: { maxAgeSeconds: 10, scope: 'public' } },
  'shows.show.end': { kind: 'command', idempotency: 'natural' },
  'shows.show.get': { kind: 'query', idempotency: 'none' },
  'shows.show.golive': { kind: 'command', idempotency: 'natural' },
  'shows.show.kill': { kind: 'command', idempotency: 'keyed' },
  'shows.show.list': { kind: 'query', idempotency: 'none' },
  'shows.show.schedule': { kind: 'command', idempotency: 'natural' },
  'shows.viewer.join': { kind: 'command', idempotency: 'natural' },
} as const;

export type CapabilityName = keyof CapabilityContracts;
export type CommandName = { [N in CapabilityName]: CapabilityContracts[N]['kind'] extends 'command' ? N : never }[CapabilityName];
export type QueryName = { [N in CapabilityName]: CapabilityContracts[N]['kind'] extends 'query' ? N : never }[CapabilityName];
export type KeyedCommandName = { [N in CommandName]: CapabilityContracts[N]['idempotency'] extends 'keyed' ? N : never }[CommandName];
export type InputOf<N extends CapabilityName> = CapabilityContracts[N]['input'];
export type OutputOf<N extends CapabilityName> = CapabilityContracts[N]['output'];
export type ErrorCodeOf<N extends CapabilityName> = CapabilityContracts[N]['errors'];
